import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * A date-time string at UTC, such as 2007-12-03T10:15:30Z,
   *     compliant with the 'date-time' format outlined in section 5.6 of
   *     the RFC 3339 profile of the ISO 8601 standard for representation
   *     of dates and times using the Gregorian calendar.
   */
  DateTime: any;
  /** The 'Dimension' type represents dimensions as whole numeric values between `1` and `4000`. */
  Dimension: any;
  /** The 'HexColor' type represents color in `rgb:ffffff` string format. */
  HexColor: any;
  /** The 'Quality' type represents quality as whole numeric values between `1` and `100`. */
  Quality: any;
};

/** This is used to define the content that is featured on the about page [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/about) */
export type About = Entry & {
  __typename?: 'About';
  collectionLinksCollection?: Maybe<AboutCollectionLinksCollection>;
  collectionLinksCta?: Maybe<Scalars['String']>;
  contentfulMetadata: ContentfulMetadata;
  cta1SubCopy?: Maybe<Scalars['String']>;
  cta3?: Maybe<Scalars['String']>;
  faqCollection?: Maybe<AboutFaqCollection>;
  headline?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<AboutLinkingCollections>;
  sys: Sys;
  type?: Maybe<Scalars['String']>;
};


/** This is used to define the content that is featured on the about page [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/about) */
export type AboutCollectionLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** This is used to define the content that is featured on the about page [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/about) */
export type AboutCollectionLinksCtaArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** This is used to define the content that is featured on the about page [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/about) */
export type AboutCta1SubCopyArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** This is used to define the content that is featured on the about page [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/about) */
export type AboutCta3Args = {
  locale?: InputMaybe<Scalars['String']>;
};


/** This is used to define the content that is featured on the about page [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/about) */
export type AboutFaqCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** This is used to define the content that is featured on the about page [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/about) */
export type AboutHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** This is used to define the content that is featured on the about page [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/about) */
export type AboutLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** This is used to define the content that is featured on the about page [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/about) */
export type AboutTypeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type AboutCollection = {
  __typename?: 'AboutCollection';
  items: Array<Maybe<About>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type AboutCollectionLinksCollection = {
  __typename?: 'AboutCollectionLinksCollection';
  items: Array<Maybe<Link>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type AboutFaqCollection = {
  __typename?: 'AboutFaqCollection';
  items: Array<Maybe<Faq>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type AboutFilter = {
  AND?: InputMaybe<Array<InputMaybe<AboutFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AboutFilter>>>;
  collectionLinksCollection_exists?: InputMaybe<Scalars['Boolean']>;
  collectionLinksCta?: InputMaybe<Scalars['String']>;
  collectionLinksCta_contains?: InputMaybe<Scalars['String']>;
  collectionLinksCta_exists?: InputMaybe<Scalars['Boolean']>;
  collectionLinksCta_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  collectionLinksCta_not?: InputMaybe<Scalars['String']>;
  collectionLinksCta_not_contains?: InputMaybe<Scalars['String']>;
  collectionLinksCta_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta1SubCopy?: InputMaybe<Scalars['String']>;
  cta1SubCopy_contains?: InputMaybe<Scalars['String']>;
  cta1SubCopy_exists?: InputMaybe<Scalars['Boolean']>;
  cta1SubCopy_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cta1SubCopy_not?: InputMaybe<Scalars['String']>;
  cta1SubCopy_not_contains?: InputMaybe<Scalars['String']>;
  cta1SubCopy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cta3?: InputMaybe<Scalars['String']>;
  cta3_contains?: InputMaybe<Scalars['String']>;
  cta3_exists?: InputMaybe<Scalars['Boolean']>;
  cta3_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cta3_not?: InputMaybe<Scalars['String']>;
  cta3_not_contains?: InputMaybe<Scalars['String']>;
  cta3_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  faqCollection_exists?: InputMaybe<Scalars['Boolean']>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  type?: InputMaybe<Scalars['String']>;
  type_contains?: InputMaybe<Scalars['String']>;
  type_exists?: InputMaybe<Scalars['Boolean']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type_not?: InputMaybe<Scalars['String']>;
  type_not_contains?: InputMaybe<Scalars['String']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type AboutLinkingCollections = {
  __typename?: 'AboutLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type AboutLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum AboutOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/artist) */
export type Artist = Entry & {
  __typename?: 'Artist';
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<ArtistLinkingCollections>;
  name?: Maybe<Scalars['String']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/artist) */
export type ArtistLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/artist) */
export type ArtistNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type ArtistCollection = {
  __typename?: 'ArtistCollection';
  items: Array<Maybe<Artist>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type ArtistFilter = {
  AND?: InputMaybe<Array<InputMaybe<ArtistFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ArtistFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type ArtistLinkingCollections = {
  __typename?: 'ArtistLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type ArtistLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum ArtistOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Represents a binary file in a space. An asset can be any file type. */
export type Asset = {
  __typename?: 'Asset';
  contentType?: Maybe<Scalars['String']>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  linkedFrom?: Maybe<AssetLinkingCollections>;
  size?: Maybe<Scalars['Int']>;
  sys: Sys;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetContentTypeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetFileNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetHeightArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetSizeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetUrlArgs = {
  locale?: InputMaybe<Scalars['String']>;
  transform?: InputMaybe<ImageTransformOptions>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetWidthArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type AssetCollection = {
  __typename?: 'AssetCollection';
  items: Array<Maybe<Asset>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type AssetFilter = {
  AND?: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  contentType?: InputMaybe<Scalars['String']>;
  contentType_contains?: InputMaybe<Scalars['String']>;
  contentType_exists?: InputMaybe<Scalars['Boolean']>;
  contentType_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentType_not?: InputMaybe<Scalars['String']>;
  contentType_not_contains?: InputMaybe<Scalars['String']>;
  contentType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']>;
  description_contains?: InputMaybe<Scalars['String']>;
  description_exists?: InputMaybe<Scalars['Boolean']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_not?: InputMaybe<Scalars['String']>;
  description_not_contains?: InputMaybe<Scalars['String']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fileName?: InputMaybe<Scalars['String']>;
  fileName_contains?: InputMaybe<Scalars['String']>;
  fileName_exists?: InputMaybe<Scalars['Boolean']>;
  fileName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fileName_not?: InputMaybe<Scalars['String']>;
  fileName_not_contains?: InputMaybe<Scalars['String']>;
  fileName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  height?: InputMaybe<Scalars['Int']>;
  height_exists?: InputMaybe<Scalars['Boolean']>;
  height_gt?: InputMaybe<Scalars['Int']>;
  height_gte?: InputMaybe<Scalars['Int']>;
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  height_lt?: InputMaybe<Scalars['Int']>;
  height_lte?: InputMaybe<Scalars['Int']>;
  height_not?: InputMaybe<Scalars['Int']>;
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  size?: InputMaybe<Scalars['Int']>;
  size_exists?: InputMaybe<Scalars['Boolean']>;
  size_gt?: InputMaybe<Scalars['Int']>;
  size_gte?: InputMaybe<Scalars['Int']>;
  size_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  size_lt?: InputMaybe<Scalars['Int']>;
  size_lte?: InputMaybe<Scalars['Int']>;
  size_not?: InputMaybe<Scalars['Int']>;
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url?: InputMaybe<Scalars['String']>;
  url_contains?: InputMaybe<Scalars['String']>;
  url_exists?: InputMaybe<Scalars['Boolean']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url_not?: InputMaybe<Scalars['String']>;
  url_not_contains?: InputMaybe<Scalars['String']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  width?: InputMaybe<Scalars['Int']>;
  width_exists?: InputMaybe<Scalars['Boolean']>;
  width_gt?: InputMaybe<Scalars['Int']>;
  width_gte?: InputMaybe<Scalars['Int']>;
  width_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  width_lt?: InputMaybe<Scalars['Int']>;
  width_lte?: InputMaybe<Scalars['Int']>;
  width_not?: InputMaybe<Scalars['Int']>;
  width_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type AssetLinkingCollections = {
  __typename?: 'AssetLinkingCollections';
  collectionCollection?: Maybe<CollectionCollection>;
  communityProjectsCollection?: Maybe<CommunityProjectsCollection>;
  entryCollection?: Maybe<EntryCollection>;
  salesPageCollection?: Maybe<SalesPageCollection>;
};


export type AssetLinkingCollectionsCollectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsCommunityProjectsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsSalesPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum AssetOrder {
  ContentTypeAsc = 'contentType_ASC',
  ContentTypeDesc = 'contentType_DESC',
  FileNameAsc = 'fileName_ASC',
  FileNameDesc = 'fileName_DESC',
  HeightAsc = 'height_ASC',
  HeightDesc = 'height_DESC',
  SizeAsc = 'size_ASC',
  SizeDesc = 'size_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC',
  WidthAsc = 'width_ASC',
  WidthDesc = 'width_DESC'
}

/** a collection of photographs from a specific photographer or a themed collection of photographers [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/collection) */
export type Collection = Entry & {
  __typename?: 'Collection';
  cid?: Maybe<Scalars['String']>;
  commission?: Maybe<Commision>;
  contentfulMetadata: ContentfulMetadata;
  droptime?: Maybe<Scalars['DateTime']>;
  etherscan?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Asset>;
  linkedFrom?: Maybe<CollectionLinkingCollections>;
  name?: Maybe<Scalars['String']>;
  opensea?: Maybe<Scalars['String']>;
  projectDescription?: Maybe<Scalars['String']>;
  projectName?: Maybe<Scalars['String']>;
  season?: Maybe<CommissionSeason>;
  slug?: Maybe<Scalars['String']>;
  sys: Sys;
  tokenIdEnd?: Maybe<Scalars['Int']>;
  tokenIdStart?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};


/** a collection of photographs from a specific photographer or a themed collection of photographers [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/collection) */
export type CollectionCidArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** a collection of photographs from a specific photographer or a themed collection of photographers [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/collection) */
export type CollectionCommissionArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** a collection of photographs from a specific photographer or a themed collection of photographers [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/collection) */
export type CollectionDroptimeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** a collection of photographs from a specific photographer or a themed collection of photographers [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/collection) */
export type CollectionEtherscanArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** a collection of photographs from a specific photographer or a themed collection of photographers [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/collection) */
export type CollectionIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** a collection of photographs from a specific photographer or a themed collection of photographers [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/collection) */
export type CollectionImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** a collection of photographs from a specific photographer or a themed collection of photographers [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/collection) */
export type CollectionLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** a collection of photographs from a specific photographer or a themed collection of photographers [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/collection) */
export type CollectionNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** a collection of photographs from a specific photographer or a themed collection of photographers [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/collection) */
export type CollectionOpenseaArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** a collection of photographs from a specific photographer or a themed collection of photographers [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/collection) */
export type CollectionProjectDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** a collection of photographs from a specific photographer or a themed collection of photographers [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/collection) */
export type CollectionProjectNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** a collection of photographs from a specific photographer or a themed collection of photographers [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/collection) */
export type CollectionSeasonArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** a collection of photographs from a specific photographer or a themed collection of photographers [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/collection) */
export type CollectionSlugArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** a collection of photographs from a specific photographer or a themed collection of photographers [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/collection) */
export type CollectionTokenIdEndArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** a collection of photographs from a specific photographer or a themed collection of photographers [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/collection) */
export type CollectionTokenIdStartArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** a collection of photographs from a specific photographer or a themed collection of photographers [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/collection) */
export type CollectionTypeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type CollectionCollection = {
  __typename?: 'CollectionCollection';
  items: Array<Maybe<Collection>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type CollectionFilter = {
  AND?: InputMaybe<Array<InputMaybe<CollectionFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CollectionFilter>>>;
  cid?: InputMaybe<Scalars['String']>;
  cid_contains?: InputMaybe<Scalars['String']>;
  cid_exists?: InputMaybe<Scalars['Boolean']>;
  cid_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cid_not?: InputMaybe<Scalars['String']>;
  cid_not_contains?: InputMaybe<Scalars['String']>;
  cid_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  commission?: InputMaybe<CfCommisionNestedFilter>;
  commission_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  droptime?: InputMaybe<Scalars['DateTime']>;
  droptime_exists?: InputMaybe<Scalars['Boolean']>;
  droptime_gt?: InputMaybe<Scalars['DateTime']>;
  droptime_gte?: InputMaybe<Scalars['DateTime']>;
  droptime_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  droptime_lt?: InputMaybe<Scalars['DateTime']>;
  droptime_lte?: InputMaybe<Scalars['DateTime']>;
  droptime_not?: InputMaybe<Scalars['DateTime']>;
  droptime_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  etherscan?: InputMaybe<Scalars['String']>;
  etherscan_contains?: InputMaybe<Scalars['String']>;
  etherscan_exists?: InputMaybe<Scalars['Boolean']>;
  etherscan_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  etherscan_not?: InputMaybe<Scalars['String']>;
  etherscan_not_contains?: InputMaybe<Scalars['String']>;
  etherscan_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Int']>;
  id_exists?: InputMaybe<Scalars['Boolean']>;
  id_gt?: InputMaybe<Scalars['Int']>;
  id_gte?: InputMaybe<Scalars['Int']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id_lt?: InputMaybe<Scalars['Int']>;
  id_lte?: InputMaybe<Scalars['Int']>;
  id_not?: InputMaybe<Scalars['Int']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  opensea?: InputMaybe<Scalars['String']>;
  opensea_contains?: InputMaybe<Scalars['String']>;
  opensea_exists?: InputMaybe<Scalars['Boolean']>;
  opensea_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  opensea_not?: InputMaybe<Scalars['String']>;
  opensea_not_contains?: InputMaybe<Scalars['String']>;
  opensea_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  projectDescription?: InputMaybe<Scalars['String']>;
  projectDescription_contains?: InputMaybe<Scalars['String']>;
  projectDescription_exists?: InputMaybe<Scalars['Boolean']>;
  projectDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  projectDescription_not?: InputMaybe<Scalars['String']>;
  projectDescription_not_contains?: InputMaybe<Scalars['String']>;
  projectDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  projectName?: InputMaybe<Scalars['String']>;
  projectName_contains?: InputMaybe<Scalars['String']>;
  projectName_exists?: InputMaybe<Scalars['Boolean']>;
  projectName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  projectName_not?: InputMaybe<Scalars['String']>;
  projectName_not_contains?: InputMaybe<Scalars['String']>;
  projectName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  season?: InputMaybe<CfCommissionSeasonNestedFilter>;
  season_exists?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  slug_contains?: InputMaybe<Scalars['String']>;
  slug_exists?: InputMaybe<Scalars['Boolean']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug_not?: InputMaybe<Scalars['String']>;
  slug_not_contains?: InputMaybe<Scalars['String']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  tokenIdEnd?: InputMaybe<Scalars['Int']>;
  tokenIdEnd_exists?: InputMaybe<Scalars['Boolean']>;
  tokenIdEnd_gt?: InputMaybe<Scalars['Int']>;
  tokenIdEnd_gte?: InputMaybe<Scalars['Int']>;
  tokenIdEnd_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  tokenIdEnd_lt?: InputMaybe<Scalars['Int']>;
  tokenIdEnd_lte?: InputMaybe<Scalars['Int']>;
  tokenIdEnd_not?: InputMaybe<Scalars['Int']>;
  tokenIdEnd_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  tokenIdStart?: InputMaybe<Scalars['Int']>;
  tokenIdStart_exists?: InputMaybe<Scalars['Boolean']>;
  tokenIdStart_gt?: InputMaybe<Scalars['Int']>;
  tokenIdStart_gte?: InputMaybe<Scalars['Int']>;
  tokenIdStart_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  tokenIdStart_lt?: InputMaybe<Scalars['Int']>;
  tokenIdStart_lte?: InputMaybe<Scalars['Int']>;
  tokenIdStart_not?: InputMaybe<Scalars['Int']>;
  tokenIdStart_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  type?: InputMaybe<Scalars['String']>;
  type_contains?: InputMaybe<Scalars['String']>;
  type_exists?: InputMaybe<Scalars['Boolean']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type_not?: InputMaybe<Scalars['String']>;
  type_not_contains?: InputMaybe<Scalars['String']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CollectionLinkingCollections = {
  __typename?: 'CollectionLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  homepageCollection?: Maybe<HomepageCollection>;
};


export type CollectionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CollectionLinkingCollectionsHomepageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum CollectionOrder {
  CidAsc = 'cid_ASC',
  CidDesc = 'cid_DESC',
  DroptimeAsc = 'droptime_ASC',
  DroptimeDesc = 'droptime_DESC',
  EtherscanAsc = 'etherscan_ASC',
  EtherscanDesc = 'etherscan_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  OpenseaAsc = 'opensea_ASC',
  OpenseaDesc = 'opensea_DESC',
  ProjectNameAsc = 'projectName_ASC',
  ProjectNameDesc = 'projectName_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TokenIdEndAsc = 'tokenIdEnd_ASC',
  TokenIdEndDesc = 'tokenIdEnd_DESC',
  TokenIdStartAsc = 'tokenIdStart_ASC',
  TokenIdStartDesc = 'tokenIdStart_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

/** Used to define content on the "Collectors" page [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/collectors) */
export type Collectors = Entry & {
  __typename?: 'Collectors';
  contentfulMetadata: ContentfulMetadata;
  cta1SubCopy?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<CollectorsLinkingCollections>;
  sys: Sys;
  type?: Maybe<Scalars['String']>;
};


/** Used to define content on the "Collectors" page [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/collectors) */
export type CollectorsCta1SubCopyArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Used to define content on the "Collectors" page [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/collectors) */
export type CollectorsHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Used to define content on the "Collectors" page [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/collectors) */
export type CollectorsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Used to define content on the "Collectors" page [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/collectors) */
export type CollectorsTypeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type CollectorsCollection = {
  __typename?: 'CollectorsCollection';
  items: Array<Maybe<Collectors>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type CollectorsFilter = {
  AND?: InputMaybe<Array<InputMaybe<CollectorsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CollectorsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta1SubCopy?: InputMaybe<Scalars['String']>;
  cta1SubCopy_contains?: InputMaybe<Scalars['String']>;
  cta1SubCopy_exists?: InputMaybe<Scalars['Boolean']>;
  cta1SubCopy_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cta1SubCopy_not?: InputMaybe<Scalars['String']>;
  cta1SubCopy_not_contains?: InputMaybe<Scalars['String']>;
  cta1SubCopy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  type?: InputMaybe<Scalars['String']>;
  type_contains?: InputMaybe<Scalars['String']>;
  type_exists?: InputMaybe<Scalars['Boolean']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type_not?: InputMaybe<Scalars['String']>;
  type_not_contains?: InputMaybe<Scalars['String']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CollectorsLinkingCollections = {
  __typename?: 'CollectorsLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type CollectorsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum CollectorsOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

/** different tiers are themed based on the content contained within. contains seasons, collections from a specific artist, tier that can be subscribed to via a season pass [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/commision) */
export type Commision = Entry & {
  __typename?: 'Commision';
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<CommisionLinkingCollections>;
  name?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  sys: Sys;
};


/** different tiers are themed based on the content contained within. contains seasons, collections from a specific artist, tier that can be subscribed to via a season pass [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/commision) */
export type CommisionDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** different tiers are themed based on the content contained within. contains seasons, collections from a specific artist, tier that can be subscribed to via a season pass [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/commision) */
export type CommisionLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** different tiers are themed based on the content contained within. contains seasons, collections from a specific artist, tier that can be subscribed to via a season pass [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/commision) */
export type CommisionNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** different tiers are themed based on the content contained within. contains seasons, collections from a specific artist, tier that can be subscribed to via a season pass [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/commision) */
export type CommisionShortDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** different tiers are themed based on the content contained within. contains seasons, collections from a specific artist, tier that can be subscribed to via a season pass [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/commision) */
export type CommisionSlugArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type CommisionCollection = {
  __typename?: 'CommisionCollection';
  items: Array<Maybe<Commision>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type CommisionFilter = {
  AND?: InputMaybe<Array<InputMaybe<CommisionFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CommisionFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']>;
  description_contains?: InputMaybe<Scalars['String']>;
  description_exists?: InputMaybe<Scalars['Boolean']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_not?: InputMaybe<Scalars['String']>;
  description_not_contains?: InputMaybe<Scalars['String']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  shortDescription?: InputMaybe<Scalars['String']>;
  shortDescription_contains?: InputMaybe<Scalars['String']>;
  shortDescription_exists?: InputMaybe<Scalars['Boolean']>;
  shortDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  shortDescription_not?: InputMaybe<Scalars['String']>;
  shortDescription_not_contains?: InputMaybe<Scalars['String']>;
  shortDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slug_contains?: InputMaybe<Scalars['String']>;
  slug_exists?: InputMaybe<Scalars['Boolean']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug_not?: InputMaybe<Scalars['String']>;
  slug_not_contains?: InputMaybe<Scalars['String']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CommisionLinkingCollections = {
  __typename?: 'CommisionLinkingCollections';
  collectionCollection?: Maybe<CollectionCollection>;
  commissionSeasonCollection?: Maybe<CommissionSeasonCollection>;
  entryCollection?: Maybe<EntryCollection>;
  salesPageCollection?: Maybe<SalesPageCollection>;
};


export type CommisionLinkingCollectionsCollectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CommisionLinkingCollectionsCommissionSeasonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CommisionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CommisionLinkingCollectionsSalesPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum CommisionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Each commission of artists has a season that represents a period of time you can buy a pass to access NFTs for [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/commissionSeason) */
export type CommissionSeason = Entry & {
  __typename?: 'CommissionSeason';
  availablePasses?: Maybe<Scalars['Int']>;
  commission?: Maybe<Commision>;
  contentfulMetadata: ContentfulMetadata;
  contractAddress?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  droptime?: Maybe<Scalars['DateTime']>;
  linkedFrom?: Maybe<CommissionSeasonLinkingCollections>;
  name?: Maybe<Scalars['String']>;
  nftsPerPass?: Maybe<Scalars['Int']>;
  passPrice?: Maybe<Scalars['Float']>;
  seasonNumber?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sys: Sys;
  totalPasses?: Maybe<Scalars['Int']>;
};


/** Each commission of artists has a season that represents a period of time you can buy a pass to access NFTs for [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/commissionSeason) */
export type CommissionSeasonAvailablePassesArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Each commission of artists has a season that represents a period of time you can buy a pass to access NFTs for [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/commissionSeason) */
export type CommissionSeasonCommissionArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Each commission of artists has a season that represents a period of time you can buy a pass to access NFTs for [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/commissionSeason) */
export type CommissionSeasonContractAddressArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Each commission of artists has a season that represents a period of time you can buy a pass to access NFTs for [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/commissionSeason) */
export type CommissionSeasonDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Each commission of artists has a season that represents a period of time you can buy a pass to access NFTs for [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/commissionSeason) */
export type CommissionSeasonDroptimeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Each commission of artists has a season that represents a period of time you can buy a pass to access NFTs for [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/commissionSeason) */
export type CommissionSeasonLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Each commission of artists has a season that represents a period of time you can buy a pass to access NFTs for [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/commissionSeason) */
export type CommissionSeasonNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Each commission of artists has a season that represents a period of time you can buy a pass to access NFTs for [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/commissionSeason) */
export type CommissionSeasonNftsPerPassArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Each commission of artists has a season that represents a period of time you can buy a pass to access NFTs for [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/commissionSeason) */
export type CommissionSeasonPassPriceArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Each commission of artists has a season that represents a period of time you can buy a pass to access NFTs for [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/commissionSeason) */
export type CommissionSeasonSeasonNumberArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Each commission of artists has a season that represents a period of time you can buy a pass to access NFTs for [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/commissionSeason) */
export type CommissionSeasonSlugArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Each commission of artists has a season that represents a period of time you can buy a pass to access NFTs for [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/commissionSeason) */
export type CommissionSeasonTotalPassesArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type CommissionSeasonCollection = {
  __typename?: 'CommissionSeasonCollection';
  items: Array<Maybe<CommissionSeason>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type CommissionSeasonFilter = {
  AND?: InputMaybe<Array<InputMaybe<CommissionSeasonFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CommissionSeasonFilter>>>;
  availablePasses?: InputMaybe<Scalars['Int']>;
  availablePasses_exists?: InputMaybe<Scalars['Boolean']>;
  availablePasses_gt?: InputMaybe<Scalars['Int']>;
  availablePasses_gte?: InputMaybe<Scalars['Int']>;
  availablePasses_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  availablePasses_lt?: InputMaybe<Scalars['Int']>;
  availablePasses_lte?: InputMaybe<Scalars['Int']>;
  availablePasses_not?: InputMaybe<Scalars['Int']>;
  availablePasses_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  commission?: InputMaybe<CfCommisionNestedFilter>;
  commission_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  contractAddress?: InputMaybe<Scalars['String']>;
  contractAddress_contains?: InputMaybe<Scalars['String']>;
  contractAddress_exists?: InputMaybe<Scalars['Boolean']>;
  contractAddress_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contractAddress_not?: InputMaybe<Scalars['String']>;
  contractAddress_not_contains?: InputMaybe<Scalars['String']>;
  contractAddress_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  description_contains?: InputMaybe<Scalars['String']>;
  description_exists?: InputMaybe<Scalars['Boolean']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_not?: InputMaybe<Scalars['String']>;
  description_not_contains?: InputMaybe<Scalars['String']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  droptime?: InputMaybe<Scalars['DateTime']>;
  droptime_exists?: InputMaybe<Scalars['Boolean']>;
  droptime_gt?: InputMaybe<Scalars['DateTime']>;
  droptime_gte?: InputMaybe<Scalars['DateTime']>;
  droptime_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  droptime_lt?: InputMaybe<Scalars['DateTime']>;
  droptime_lte?: InputMaybe<Scalars['DateTime']>;
  droptime_not?: InputMaybe<Scalars['DateTime']>;
  droptime_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nftsPerPass?: InputMaybe<Scalars['Int']>;
  nftsPerPass_exists?: InputMaybe<Scalars['Boolean']>;
  nftsPerPass_gt?: InputMaybe<Scalars['Int']>;
  nftsPerPass_gte?: InputMaybe<Scalars['Int']>;
  nftsPerPass_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  nftsPerPass_lt?: InputMaybe<Scalars['Int']>;
  nftsPerPass_lte?: InputMaybe<Scalars['Int']>;
  nftsPerPass_not?: InputMaybe<Scalars['Int']>;
  nftsPerPass_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  passPrice?: InputMaybe<Scalars['Float']>;
  passPrice_exists?: InputMaybe<Scalars['Boolean']>;
  passPrice_gt?: InputMaybe<Scalars['Float']>;
  passPrice_gte?: InputMaybe<Scalars['Float']>;
  passPrice_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  passPrice_lt?: InputMaybe<Scalars['Float']>;
  passPrice_lte?: InputMaybe<Scalars['Float']>;
  passPrice_not?: InputMaybe<Scalars['Float']>;
  passPrice_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  seasonNumber?: InputMaybe<Scalars['Int']>;
  seasonNumber_exists?: InputMaybe<Scalars['Boolean']>;
  seasonNumber_gt?: InputMaybe<Scalars['Int']>;
  seasonNumber_gte?: InputMaybe<Scalars['Int']>;
  seasonNumber_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  seasonNumber_lt?: InputMaybe<Scalars['Int']>;
  seasonNumber_lte?: InputMaybe<Scalars['Int']>;
  seasonNumber_not?: InputMaybe<Scalars['Int']>;
  seasonNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slug_contains?: InputMaybe<Scalars['String']>;
  slug_exists?: InputMaybe<Scalars['Boolean']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug_not?: InputMaybe<Scalars['String']>;
  slug_not_contains?: InputMaybe<Scalars['String']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  totalPasses?: InputMaybe<Scalars['Int']>;
  totalPasses_exists?: InputMaybe<Scalars['Boolean']>;
  totalPasses_gt?: InputMaybe<Scalars['Int']>;
  totalPasses_gte?: InputMaybe<Scalars['Int']>;
  totalPasses_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  totalPasses_lt?: InputMaybe<Scalars['Int']>;
  totalPasses_lte?: InputMaybe<Scalars['Int']>;
  totalPasses_not?: InputMaybe<Scalars['Int']>;
  totalPasses_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type CommissionSeasonLinkingCollections = {
  __typename?: 'CommissionSeasonLinkingCollections';
  collectionCollection?: Maybe<CollectionCollection>;
  entryCollection?: Maybe<EntryCollection>;
};


export type CommissionSeasonLinkingCollectionsCollectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CommissionSeasonLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum CommissionSeasonOrder {
  AvailablePassesAsc = 'availablePasses_ASC',
  AvailablePassesDesc = 'availablePasses_DESC',
  DroptimeAsc = 'droptime_ASC',
  DroptimeDesc = 'droptime_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  NftsPerPassAsc = 'nftsPerPass_ASC',
  NftsPerPassDesc = 'nftsPerPass_DESC',
  PassPriceAsc = 'passPrice_ASC',
  PassPriceDesc = 'passPrice_DESC',
  SeasonNumberAsc = 'seasonNumber_ASC',
  SeasonNumberDesc = 'seasonNumber_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TotalPassesAsc = 'totalPasses_ASC',
  TotalPassesDesc = 'totalPasses_DESC'
}

/** collections from our community that comprise of many artists [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/communityProjects) */
export type CommunityProjects = Entry & {
  __typename?: 'CommunityProjects';
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Asset>;
  link?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<CommunityProjectsLinkingCollections>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sys: Sys;
};


/** collections from our community that comprise of many artists [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/communityProjects) */
export type CommunityProjectsDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** collections from our community that comprise of many artists [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/communityProjects) */
export type CommunityProjectsImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** collections from our community that comprise of many artists [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/communityProjects) */
export type CommunityProjectsLinkArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** collections from our community that comprise of many artists [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/communityProjects) */
export type CommunityProjectsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** collections from our community that comprise of many artists [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/communityProjects) */
export type CommunityProjectsNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** collections from our community that comprise of many artists [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/communityProjects) */
export type CommunityProjectsOrderArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** collections from our community that comprise of many artists [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/communityProjects) */
export type CommunityProjectsSlugArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type CommunityProjectsCollection = {
  __typename?: 'CommunityProjectsCollection';
  items: Array<Maybe<CommunityProjects>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type CommunityProjectsFilter = {
  AND?: InputMaybe<Array<InputMaybe<CommunityProjectsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CommunityProjectsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']>;
  description_contains?: InputMaybe<Scalars['String']>;
  description_exists?: InputMaybe<Scalars['Boolean']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_not?: InputMaybe<Scalars['String']>;
  description_not_contains?: InputMaybe<Scalars['String']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']>;
  link?: InputMaybe<Scalars['String']>;
  link_contains?: InputMaybe<Scalars['String']>;
  link_exists?: InputMaybe<Scalars['Boolean']>;
  link_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  link_not?: InputMaybe<Scalars['String']>;
  link_not_contains?: InputMaybe<Scalars['String']>;
  link_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  order?: InputMaybe<Scalars['Int']>;
  order_exists?: InputMaybe<Scalars['Boolean']>;
  order_gt?: InputMaybe<Scalars['Int']>;
  order_gte?: InputMaybe<Scalars['Int']>;
  order_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  order_lt?: InputMaybe<Scalars['Int']>;
  order_lte?: InputMaybe<Scalars['Int']>;
  order_not?: InputMaybe<Scalars['Int']>;
  order_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slug_contains?: InputMaybe<Scalars['String']>;
  slug_exists?: InputMaybe<Scalars['Boolean']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug_not?: InputMaybe<Scalars['String']>;
  slug_not_contains?: InputMaybe<Scalars['String']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CommunityProjectsLinkingCollections = {
  __typename?: 'CommunityProjectsLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type CommunityProjectsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum CommunityProjectsOrder {
  LinkAsc = 'link_ASC',
  LinkDesc = 'link_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  OrderAsc = 'order_ASC',
  OrderDesc = 'order_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** "Commision Tier" equivalent content for the Community Projects top level page and description [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/communityProjectsPage) */
export type CommunityProjectsPage = Entry & {
  __typename?: 'CommunityProjectsPage';
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<CommunityProjectsPageLinkingCollections>;
  shortDescription?: Maybe<Scalars['String']>;
  sys: Sys;
  type?: Maybe<Scalars['String']>;
};


/** "Commision Tier" equivalent content for the Community Projects top level page and description [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/communityProjectsPage) */
export type CommunityProjectsPageDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** "Commision Tier" equivalent content for the Community Projects top level page and description [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/communityProjectsPage) */
export type CommunityProjectsPageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** "Commision Tier" equivalent content for the Community Projects top level page and description [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/communityProjectsPage) */
export type CommunityProjectsPageShortDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** "Commision Tier" equivalent content for the Community Projects top level page and description [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/communityProjectsPage) */
export type CommunityProjectsPageTypeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type CommunityProjectsPageCollection = {
  __typename?: 'CommunityProjectsPageCollection';
  items: Array<Maybe<CommunityProjectsPage>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type CommunityProjectsPageFilter = {
  AND?: InputMaybe<Array<InputMaybe<CommunityProjectsPageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CommunityProjectsPageFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']>;
  description_contains?: InputMaybe<Scalars['String']>;
  description_exists?: InputMaybe<Scalars['Boolean']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_not?: InputMaybe<Scalars['String']>;
  description_not_contains?: InputMaybe<Scalars['String']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  shortDescription?: InputMaybe<Scalars['String']>;
  shortDescription_contains?: InputMaybe<Scalars['String']>;
  shortDescription_exists?: InputMaybe<Scalars['Boolean']>;
  shortDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  shortDescription_not?: InputMaybe<Scalars['String']>;
  shortDescription_not_contains?: InputMaybe<Scalars['String']>;
  shortDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  type?: InputMaybe<Scalars['String']>;
  type_contains?: InputMaybe<Scalars['String']>;
  type_exists?: InputMaybe<Scalars['Boolean']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type_not?: InputMaybe<Scalars['String']>;
  type_not_contains?: InputMaybe<Scalars['String']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CommunityProjectsPageLinkingCollections = {
  __typename?: 'CommunityProjectsPageLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type CommunityProjectsPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum CommunityProjectsPageOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

/** block of copy with a title and description [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/contentBlock) */
export type ContentBlock = Entry & {
  __typename?: 'ContentBlock';
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<ContentBlockLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']>;
};


/** block of copy with a title and description [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/contentBlock) */
export type ContentBlockDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** block of copy with a title and description [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/contentBlock) */
export type ContentBlockLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** block of copy with a title and description [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/contentBlock) */
export type ContentBlockTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type ContentBlockCollection = {
  __typename?: 'ContentBlockCollection';
  items: Array<Maybe<ContentBlock>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type ContentBlockFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentBlockFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentBlockFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']>;
  description_contains?: InputMaybe<Scalars['String']>;
  description_exists?: InputMaybe<Scalars['Boolean']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_not?: InputMaybe<Scalars['String']>;
  description_not_contains?: InputMaybe<Scalars['String']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ContentBlockLinkingCollections = {
  __typename?: 'ContentBlockLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  homepageCollection?: Maybe<HomepageCollection>;
};


export type ContentBlockLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ContentBlockLinkingCollectionsHomepageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum ContentBlockOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ContentfulMetadata = {
  __typename?: 'ContentfulMetadata';
  tags: Array<Maybe<ContentfulTag>>;
};

export type ContentfulMetadataFilter = {
  tags?: InputMaybe<ContentfulMetadataTagsFilter>;
  tags_exists?: InputMaybe<Scalars['Boolean']>;
};

export type ContentfulMetadataTagsFilter = {
  id_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/**
 * Represents a tag entity for finding and organizing content easily.
 *     Find out more here: https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-tags
 */
export type ContentfulTag = {
  __typename?: 'ContentfulTag';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Entry = {
  contentfulMetadata: ContentfulMetadata;
  sys: Sys;
};

export type EntryCollection = {
  __typename?: 'EntryCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type EntryFilter = {
  AND?: InputMaybe<Array<InputMaybe<EntryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<EntryFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export enum EntryOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/faq) */
export type Faq = Entry & {
  __typename?: 'Faq';
  answer?: Maybe<Scalars['String']>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<FaqLinkingCollections>;
  question?: Maybe<Scalars['String']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/faq) */
export type FaqAnswerArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/faq) */
export type FaqLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/faq) */
export type FaqQuestionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type FaqCollection = {
  __typename?: 'FaqCollection';
  items: Array<Maybe<Faq>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type FaqFilter = {
  AND?: InputMaybe<Array<InputMaybe<FaqFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FaqFilter>>>;
  answer?: InputMaybe<Scalars['String']>;
  answer_contains?: InputMaybe<Scalars['String']>;
  answer_exists?: InputMaybe<Scalars['Boolean']>;
  answer_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  answer_not?: InputMaybe<Scalars['String']>;
  answer_not_contains?: InputMaybe<Scalars['String']>;
  answer_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  question?: InputMaybe<Scalars['String']>;
  question_contains?: InputMaybe<Scalars['String']>;
  question_exists?: InputMaybe<Scalars['Boolean']>;
  question_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  question_not?: InputMaybe<Scalars['String']>;
  question_not_contains?: InputMaybe<Scalars['String']>;
  question_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type FaqLinkingCollections = {
  __typename?: 'FaqLinkingCollections';
  aboutCollection?: Maybe<AboutCollection>;
  entryCollection?: Maybe<EntryCollection>;
  howItWorksCollection?: Maybe<HowItWorksCollection>;
};


export type FaqLinkingCollectionsAboutCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type FaqLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type FaqLinkingCollectionsHowItWorksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum FaqOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** This is used to define the content that is featured on the homepage [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/homepage) */
export type Homepage = Entry & {
  __typename?: 'Homepage';
  annonuncementCtaButtonText?: Maybe<Scalars['String']>;
  announcementCta?: Maybe<Scalars['String']>;
  announcementCtaLink?: Maybe<Scalars['String']>;
  announcementCtaSubCopy?: Maybe<Scalars['String']>;
  contentfulMetadata: ContentfulMetadata;
  cta2?: Maybe<Scalars['String']>;
  cta2SubCopy?: Maybe<Scalars['String']>;
  cta3?: Maybe<Scalars['String']>;
  cta3SubCopy?: Maybe<Scalars['String']>;
  featuredCollectionsCollection?: Maybe<HomepageFeaturedCollectionsCollection>;
  footerBlurb?: Maybe<Scalars['String']>;
  footerLinksColumnOneCollection?: Maybe<HomepageFooterLinksColumnOneCollection>;
  footerLinksColumnTwoCollection?: Maybe<HomepageFooterLinksColumnTwoCollection>;
  headline?: Maybe<Scalars['String']>;
  isAnnouncementVisible?: Maybe<Scalars['Boolean']>;
  linkedFrom?: Maybe<HomepageLinkingCollections>;
  statsCollection?: Maybe<HomepageStatsCollection>;
  statsHeader?: Maybe<Scalars['String']>;
  sys: Sys;
  type?: Maybe<Scalars['String']>;
};


/** This is used to define the content that is featured on the homepage [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/homepage) */
export type HomepageAnnonuncementCtaButtonTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** This is used to define the content that is featured on the homepage [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/homepage) */
export type HomepageAnnouncementCtaArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** This is used to define the content that is featured on the homepage [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/homepage) */
export type HomepageAnnouncementCtaLinkArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** This is used to define the content that is featured on the homepage [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/homepage) */
export type HomepageAnnouncementCtaSubCopyArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** This is used to define the content that is featured on the homepage [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/homepage) */
export type HomepageCta2Args = {
  locale?: InputMaybe<Scalars['String']>;
};


/** This is used to define the content that is featured on the homepage [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/homepage) */
export type HomepageCta2SubCopyArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** This is used to define the content that is featured on the homepage [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/homepage) */
export type HomepageCta3Args = {
  locale?: InputMaybe<Scalars['String']>;
};


/** This is used to define the content that is featured on the homepage [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/homepage) */
export type HomepageCta3SubCopyArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** This is used to define the content that is featured on the homepage [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/homepage) */
export type HomepageFeaturedCollectionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** This is used to define the content that is featured on the homepage [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/homepage) */
export type HomepageFooterBlurbArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** This is used to define the content that is featured on the homepage [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/homepage) */
export type HomepageFooterLinksColumnOneCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** This is used to define the content that is featured on the homepage [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/homepage) */
export type HomepageFooterLinksColumnTwoCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** This is used to define the content that is featured on the homepage [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/homepage) */
export type HomepageHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** This is used to define the content that is featured on the homepage [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/homepage) */
export type HomepageIsAnnouncementVisibleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** This is used to define the content that is featured on the homepage [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/homepage) */
export type HomepageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** This is used to define the content that is featured on the homepage [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/homepage) */
export type HomepageStatsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** This is used to define the content that is featured on the homepage [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/homepage) */
export type HomepageStatsHeaderArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** This is used to define the content that is featured on the homepage [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/homepage) */
export type HomepageTypeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type HomepageCollection = {
  __typename?: 'HomepageCollection';
  items: Array<Maybe<Homepage>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type HomepageFeaturedCollectionsCollection = {
  __typename?: 'HomepageFeaturedCollectionsCollection';
  items: Array<Maybe<Collection>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type HomepageFilter = {
  AND?: InputMaybe<Array<InputMaybe<HomepageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HomepageFilter>>>;
  annonuncementCtaButtonText?: InputMaybe<Scalars['String']>;
  annonuncementCtaButtonText_contains?: InputMaybe<Scalars['String']>;
  annonuncementCtaButtonText_exists?: InputMaybe<Scalars['Boolean']>;
  annonuncementCtaButtonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  annonuncementCtaButtonText_not?: InputMaybe<Scalars['String']>;
  annonuncementCtaButtonText_not_contains?: InputMaybe<Scalars['String']>;
  annonuncementCtaButtonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  announcementCta?: InputMaybe<Scalars['String']>;
  announcementCtaLink?: InputMaybe<Scalars['String']>;
  announcementCtaLink_contains?: InputMaybe<Scalars['String']>;
  announcementCtaLink_exists?: InputMaybe<Scalars['Boolean']>;
  announcementCtaLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  announcementCtaLink_not?: InputMaybe<Scalars['String']>;
  announcementCtaLink_not_contains?: InputMaybe<Scalars['String']>;
  announcementCtaLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  announcementCtaSubCopy?: InputMaybe<Scalars['String']>;
  announcementCtaSubCopy_contains?: InputMaybe<Scalars['String']>;
  announcementCtaSubCopy_exists?: InputMaybe<Scalars['Boolean']>;
  announcementCtaSubCopy_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  announcementCtaSubCopy_not?: InputMaybe<Scalars['String']>;
  announcementCtaSubCopy_not_contains?: InputMaybe<Scalars['String']>;
  announcementCtaSubCopy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  announcementCta_contains?: InputMaybe<Scalars['String']>;
  announcementCta_exists?: InputMaybe<Scalars['Boolean']>;
  announcementCta_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  announcementCta_not?: InputMaybe<Scalars['String']>;
  announcementCta_not_contains?: InputMaybe<Scalars['String']>;
  announcementCta_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta2?: InputMaybe<Scalars['String']>;
  cta2SubCopy?: InputMaybe<Scalars['String']>;
  cta2SubCopy_contains?: InputMaybe<Scalars['String']>;
  cta2SubCopy_exists?: InputMaybe<Scalars['Boolean']>;
  cta2SubCopy_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cta2SubCopy_not?: InputMaybe<Scalars['String']>;
  cta2SubCopy_not_contains?: InputMaybe<Scalars['String']>;
  cta2SubCopy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cta2_contains?: InputMaybe<Scalars['String']>;
  cta2_exists?: InputMaybe<Scalars['Boolean']>;
  cta2_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cta2_not?: InputMaybe<Scalars['String']>;
  cta2_not_contains?: InputMaybe<Scalars['String']>;
  cta2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cta3?: InputMaybe<Scalars['String']>;
  cta3SubCopy?: InputMaybe<Scalars['String']>;
  cta3SubCopy_contains?: InputMaybe<Scalars['String']>;
  cta3SubCopy_exists?: InputMaybe<Scalars['Boolean']>;
  cta3SubCopy_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cta3SubCopy_not?: InputMaybe<Scalars['String']>;
  cta3SubCopy_not_contains?: InputMaybe<Scalars['String']>;
  cta3SubCopy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cta3_contains?: InputMaybe<Scalars['String']>;
  cta3_exists?: InputMaybe<Scalars['Boolean']>;
  cta3_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cta3_not?: InputMaybe<Scalars['String']>;
  cta3_not_contains?: InputMaybe<Scalars['String']>;
  cta3_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featuredCollectionsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  footerBlurb?: InputMaybe<Scalars['String']>;
  footerBlurb_contains?: InputMaybe<Scalars['String']>;
  footerBlurb_exists?: InputMaybe<Scalars['Boolean']>;
  footerBlurb_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  footerBlurb_not?: InputMaybe<Scalars['String']>;
  footerBlurb_not_contains?: InputMaybe<Scalars['String']>;
  footerBlurb_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  footerLinksColumnOneCollection_exists?: InputMaybe<Scalars['Boolean']>;
  footerLinksColumnTwoCollection_exists?: InputMaybe<Scalars['Boolean']>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isAnnouncementVisible?: InputMaybe<Scalars['Boolean']>;
  isAnnouncementVisible_exists?: InputMaybe<Scalars['Boolean']>;
  isAnnouncementVisible_not?: InputMaybe<Scalars['Boolean']>;
  statsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  statsHeader?: InputMaybe<Scalars['String']>;
  statsHeader_contains?: InputMaybe<Scalars['String']>;
  statsHeader_exists?: InputMaybe<Scalars['Boolean']>;
  statsHeader_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  statsHeader_not?: InputMaybe<Scalars['String']>;
  statsHeader_not_contains?: InputMaybe<Scalars['String']>;
  statsHeader_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  type?: InputMaybe<Scalars['String']>;
  type_contains?: InputMaybe<Scalars['String']>;
  type_exists?: InputMaybe<Scalars['Boolean']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type_not?: InputMaybe<Scalars['String']>;
  type_not_contains?: InputMaybe<Scalars['String']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type HomepageFooterLinksColumnOneCollection = {
  __typename?: 'HomepageFooterLinksColumnOneCollection';
  items: Array<Maybe<Link>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type HomepageFooterLinksColumnTwoCollection = {
  __typename?: 'HomepageFooterLinksColumnTwoCollection';
  items: Array<Maybe<Link>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type HomepageLinkingCollections = {
  __typename?: 'HomepageLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type HomepageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum HomepageOrder {
  AnnouncementCtaLinkAsc = 'announcementCtaLink_ASC',
  AnnouncementCtaLinkDesc = 'announcementCtaLink_DESC',
  IsAnnouncementVisibleAsc = 'isAnnouncementVisible_ASC',
  IsAnnouncementVisibleDesc = 'isAnnouncementVisible_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export type HomepageStatsCollection = {
  __typename?: 'HomepageStatsCollection';
  items: Array<Maybe<ContentBlock>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

/** This is used to define the content that is featured on the how it works page [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/howItWorks) */
export type HowItWorks = Entry & {
  __typename?: 'HowItWorks';
  contentfulMetadata: ContentfulMetadata;
  faqCollection?: Maybe<HowItWorksFaqCollection>;
  headline?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<HowItWorksLinkingCollections>;
  sys: Sys;
  type?: Maybe<Scalars['String']>;
};


/** This is used to define the content that is featured on the how it works page [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/howItWorks) */
export type HowItWorksFaqCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** This is used to define the content that is featured on the how it works page [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/howItWorks) */
export type HowItWorksHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** This is used to define the content that is featured on the how it works page [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/howItWorks) */
export type HowItWorksLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** This is used to define the content that is featured on the how it works page [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/howItWorks) */
export type HowItWorksTypeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type HowItWorksCollection = {
  __typename?: 'HowItWorksCollection';
  items: Array<Maybe<HowItWorks>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type HowItWorksFaqCollection = {
  __typename?: 'HowItWorksFaqCollection';
  items: Array<Maybe<Faq>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type HowItWorksFilter = {
  AND?: InputMaybe<Array<InputMaybe<HowItWorksFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HowItWorksFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  faqCollection_exists?: InputMaybe<Scalars['Boolean']>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  type?: InputMaybe<Scalars['String']>;
  type_contains?: InputMaybe<Scalars['String']>;
  type_exists?: InputMaybe<Scalars['Boolean']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type_not?: InputMaybe<Scalars['String']>;
  type_not_contains?: InputMaybe<Scalars['String']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type HowItWorksLinkingCollections = {
  __typename?: 'HowItWorksLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type HowItWorksLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum HowItWorksOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum ImageFormat {
  Avif = 'AVIF',
  /** JPG image format. */
  Jpg = 'JPG',
  /**
   * Progressive JPG format stores multiple passes of an image in progressively higher detail.
   *         When a progressive image is loading, the viewer will first see a lower quality pixelated version which
   *         will gradually improve in detail, until the image is fully downloaded. This is to display an image as
   *         early as possible to make the layout look as designed.
   */
  JpgProgressive = 'JPG_PROGRESSIVE',
  /** PNG image format */
  Png = 'PNG',
  /**
   * 8-bit PNG images support up to 256 colors and weigh less than the standard 24-bit PNG equivalent.
   *         The 8-bit PNG format is mostly used for simple images, such as icons or logos.
   */
  Png8 = 'PNG8',
  /** WebP image format. */
  Webp = 'WEBP'
}

export enum ImageResizeFocus {
  /** Focus the resizing on the bottom. */
  Bottom = 'BOTTOM',
  /** Focus the resizing on the bottom left. */
  BottomLeft = 'BOTTOM_LEFT',
  /** Focus the resizing on the bottom right. */
  BottomRight = 'BOTTOM_RIGHT',
  /** Focus the resizing on the center. */
  Center = 'CENTER',
  /** Focus the resizing on the largest face. */
  Face = 'FACE',
  /** Focus the resizing on the area containing all the faces. */
  Faces = 'FACES',
  /** Focus the resizing on the left. */
  Left = 'LEFT',
  /** Focus the resizing on the right. */
  Right = 'RIGHT',
  /** Focus the resizing on the top. */
  Top = 'TOP',
  /** Focus the resizing on the top left. */
  TopLeft = 'TOP_LEFT',
  /** Focus the resizing on the top right. */
  TopRight = 'TOP_RIGHT'
}

export enum ImageResizeStrategy {
  /** Crops a part of the original image to fit into the specified dimensions. */
  Crop = 'CROP',
  /** Resizes the image to the specified dimensions, cropping the image if needed. */
  Fill = 'FILL',
  /** Resizes the image to fit into the specified dimensions. */
  Fit = 'FIT',
  /**
   * Resizes the image to the specified dimensions, padding the image if needed.
   *         Uses desired background color as padding color.
   */
  Pad = 'PAD',
  /** Resizes the image to the specified dimensions, changing the original aspect ratio if needed. */
  Scale = 'SCALE',
  /** Creates a thumbnail from the image. */
  Thumb = 'THUMB'
}

export type ImageTransformOptions = {
  /**
   * Desired background color, used with corner radius or `PAD` resize strategy.
   *         Defaults to transparent (for `PNG`, `PNG8` and `WEBP`) or white (for `JPG` and `JPG_PROGRESSIVE`).
   */
  backgroundColor?: InputMaybe<Scalars['HexColor']>;
  /**
   * Desired corner radius in pixels.
   *         Results in an image with rounded corners (pass `-1` for a full circle/ellipse).
   *         Defaults to `0`. Uses desired background color as padding color,
   *         unless the format is `JPG` or `JPG_PROGRESSIVE` and resize strategy is `PAD`, then defaults to white.
   */
  cornerRadius?: InputMaybe<Scalars['Int']>;
  /** Desired image format. Defaults to the original image format. */
  format?: InputMaybe<ImageFormat>;
  /** Desired height in pixels. Defaults to the original image height. */
  height?: InputMaybe<Scalars['Dimension']>;
  /**
   * Desired quality of the image in percents.
   *         Used for `PNG8`, `JPG`, `JPG_PROGRESSIVE` and `WEBP` formats.
   */
  quality?: InputMaybe<Scalars['Quality']>;
  /** Desired resize focus area. Defaults to `CENTER`. */
  resizeFocus?: InputMaybe<ImageResizeFocus>;
  /** Desired resize strategy. Defaults to `FIT`. */
  resizeStrategy?: InputMaybe<ImageResizeStrategy>;
  /** Desired width in pixels. Defaults to the original image width. */
  width?: InputMaybe<Scalars['Dimension']>;
};

/** used to define links with a label and url [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/link) */
export type Link = Entry & {
  __typename?: 'Link';
  contentfulMetadata: ContentfulMetadata;
  label?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<LinkLinkingCollections>;
  sys: Sys;
  url?: Maybe<Scalars['String']>;
};


/** used to define links with a label and url [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/link) */
export type LinkLabelArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** used to define links with a label and url [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/link) */
export type LinkLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** used to define links with a label and url [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/link) */
export type LinkUrlArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type LinkCollection = {
  __typename?: 'LinkCollection';
  items: Array<Maybe<Link>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type LinkFilter = {
  AND?: InputMaybe<Array<InputMaybe<LinkFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<LinkFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  label?: InputMaybe<Scalars['String']>;
  label_contains?: InputMaybe<Scalars['String']>;
  label_exists?: InputMaybe<Scalars['Boolean']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  label_not?: InputMaybe<Scalars['String']>;
  label_not_contains?: InputMaybe<Scalars['String']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  url?: InputMaybe<Scalars['String']>;
  url_contains?: InputMaybe<Scalars['String']>;
  url_exists?: InputMaybe<Scalars['Boolean']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url_not?: InputMaybe<Scalars['String']>;
  url_not_contains?: InputMaybe<Scalars['String']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LinkLinkingCollections = {
  __typename?: 'LinkLinkingCollections';
  aboutCollection?: Maybe<AboutCollection>;
  entryCollection?: Maybe<EntryCollection>;
  homepageCollection?: Maybe<HomepageCollection>;
};


export type LinkLinkingCollectionsAboutCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type LinkLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type LinkLinkingCollectionsHomepageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum LinkOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

export type Query = {
  __typename?: 'Query';
  about?: Maybe<About>;
  aboutCollection?: Maybe<AboutCollection>;
  artist?: Maybe<Artist>;
  artistCollection?: Maybe<ArtistCollection>;
  asset?: Maybe<Asset>;
  assetCollection?: Maybe<AssetCollection>;
  collection?: Maybe<Collection>;
  collectionCollection?: Maybe<CollectionCollection>;
  collectors?: Maybe<Collectors>;
  collectorsCollection?: Maybe<CollectorsCollection>;
  commision?: Maybe<Commision>;
  commisionCollection?: Maybe<CommisionCollection>;
  commissionSeason?: Maybe<CommissionSeason>;
  commissionSeasonCollection?: Maybe<CommissionSeasonCollection>;
  communityProjects?: Maybe<CommunityProjects>;
  communityProjectsCollection?: Maybe<CommunityProjectsCollection>;
  communityProjectsPage?: Maybe<CommunityProjectsPage>;
  communityProjectsPageCollection?: Maybe<CommunityProjectsPageCollection>;
  contentBlock?: Maybe<ContentBlock>;
  contentBlockCollection?: Maybe<ContentBlockCollection>;
  entryCollection?: Maybe<EntryCollection>;
  faq?: Maybe<Faq>;
  faqCollection?: Maybe<FaqCollection>;
  homepage?: Maybe<Homepage>;
  homepageCollection?: Maybe<HomepageCollection>;
  howItWorks?: Maybe<HowItWorks>;
  howItWorksCollection?: Maybe<HowItWorksCollection>;
  link?: Maybe<Link>;
  linkCollection?: Maybe<LinkCollection>;
  salesPage?: Maybe<SalesPage>;
  salesPageCollection?: Maybe<SalesPageCollection>;
};


export type QueryAboutArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAboutCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<AboutOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AboutFilter>;
};


export type QueryArtistArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryArtistCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ArtistOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ArtistFilter>;
};


export type QueryAssetArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAssetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<AssetOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AssetFilter>;
};


export type QueryCollectionArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCollectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CollectionFilter>;
};


export type QueryCollectorsArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCollectorsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CollectorsOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CollectorsFilter>;
};


export type QueryCommisionArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCommisionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CommisionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CommisionFilter>;
};


export type QueryCommissionSeasonArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCommissionSeasonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CommissionSeasonOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CommissionSeasonFilter>;
};


export type QueryCommunityProjectsArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCommunityProjectsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CommunityProjectsOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CommunityProjectsFilter>;
};


export type QueryCommunityProjectsPageArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCommunityProjectsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CommunityProjectsPageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CommunityProjectsPageFilter>;
};


export type QueryContentBlockArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryContentBlockCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ContentBlockOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ContentBlockFilter>;
};


export type QueryEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<EntryOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EntryFilter>;
};


export type QueryFaqArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryFaqCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<FaqOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FaqFilter>;
};


export type QueryHomepageArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryHomepageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<HomepageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HomepageFilter>;
};


export type QueryHowItWorksArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryHowItWorksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<HowItWorksOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HowItWorksFilter>;
};


export type QueryLinkArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<LinkOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LinkFilter>;
};


export type QuerySalesPageArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySalesPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<SalesPageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SalesPageFilter>;
};

/** an abstract collection of photographs for sale, either a community project or a sale of nfts from multiple collections [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/salesPage) */
export type SalesPage = Entry & {
  __typename?: 'SalesPage';
  commission?: Maybe<Commision>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']>;
  droptime?: Maybe<Scalars['DateTime']>;
  etherscan?: Maybe<Scalars['String']>;
  image?: Maybe<Asset>;
  linkedFrom?: Maybe<SalesPageLinkingCollections>;
  name?: Maybe<Scalars['String']>;
  opensea?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  sys: Sys;
};


/** an abstract collection of photographs for sale, either a community project or a sale of nfts from multiple collections [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/salesPage) */
export type SalesPageCommissionArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** an abstract collection of photographs for sale, either a community project or a sale of nfts from multiple collections [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/salesPage) */
export type SalesPageDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** an abstract collection of photographs for sale, either a community project or a sale of nfts from multiple collections [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/salesPage) */
export type SalesPageDroptimeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** an abstract collection of photographs for sale, either a community project or a sale of nfts from multiple collections [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/salesPage) */
export type SalesPageEtherscanArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** an abstract collection of photographs for sale, either a community project or a sale of nfts from multiple collections [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/salesPage) */
export type SalesPageImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** an abstract collection of photographs for sale, either a community project or a sale of nfts from multiple collections [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/salesPage) */
export type SalesPageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** an abstract collection of photographs for sale, either a community project or a sale of nfts from multiple collections [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/salesPage) */
export type SalesPageNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** an abstract collection of photographs for sale, either a community project or a sale of nfts from multiple collections [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/salesPage) */
export type SalesPageOpenseaArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** an abstract collection of photographs for sale, either a community project or a sale of nfts from multiple collections [See type definition](https://app.contentful.com/spaces/wyiaipfqrsa6/content_types/salesPage) */
export type SalesPageSlugArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type SalesPageCollection = {
  __typename?: 'SalesPageCollection';
  items: Array<Maybe<SalesPage>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type SalesPageFilter = {
  AND?: InputMaybe<Array<InputMaybe<SalesPageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SalesPageFilter>>>;
  commission?: InputMaybe<CfCommisionNestedFilter>;
  commission_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']>;
  description_contains?: InputMaybe<Scalars['String']>;
  description_exists?: InputMaybe<Scalars['Boolean']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_not?: InputMaybe<Scalars['String']>;
  description_not_contains?: InputMaybe<Scalars['String']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  droptime?: InputMaybe<Scalars['DateTime']>;
  droptime_exists?: InputMaybe<Scalars['Boolean']>;
  droptime_gt?: InputMaybe<Scalars['DateTime']>;
  droptime_gte?: InputMaybe<Scalars['DateTime']>;
  droptime_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  droptime_lt?: InputMaybe<Scalars['DateTime']>;
  droptime_lte?: InputMaybe<Scalars['DateTime']>;
  droptime_not?: InputMaybe<Scalars['DateTime']>;
  droptime_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  etherscan?: InputMaybe<Scalars['String']>;
  etherscan_contains?: InputMaybe<Scalars['String']>;
  etherscan_exists?: InputMaybe<Scalars['Boolean']>;
  etherscan_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  etherscan_not?: InputMaybe<Scalars['String']>;
  etherscan_not_contains?: InputMaybe<Scalars['String']>;
  etherscan_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  opensea?: InputMaybe<Scalars['String']>;
  opensea_contains?: InputMaybe<Scalars['String']>;
  opensea_exists?: InputMaybe<Scalars['Boolean']>;
  opensea_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  opensea_not?: InputMaybe<Scalars['String']>;
  opensea_not_contains?: InputMaybe<Scalars['String']>;
  opensea_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slug_contains?: InputMaybe<Scalars['String']>;
  slug_exists?: InputMaybe<Scalars['Boolean']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug_not?: InputMaybe<Scalars['String']>;
  slug_not_contains?: InputMaybe<Scalars['String']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type SalesPageLinkingCollections = {
  __typename?: 'SalesPageLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type SalesPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum SalesPageOrder {
  DroptimeAsc = 'droptime_ASC',
  DroptimeDesc = 'droptime_DESC',
  EtherscanAsc = 'etherscan_ASC',
  EtherscanDesc = 'etherscan_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  OpenseaAsc = 'opensea_ASC',
  OpenseaDesc = 'opensea_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type Sys = {
  __typename?: 'Sys';
  environmentId: Scalars['String'];
  firstPublishedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  publishedVersion?: Maybe<Scalars['Int']>;
  spaceId: Scalars['String'];
};

export type SysFilter = {
  firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_exists?: InputMaybe<Scalars['Boolean']>;
  firstPublishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  firstPublishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_not?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_exists?: InputMaybe<Scalars['Boolean']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  publishedAt_exists?: InputMaybe<Scalars['Boolean']>;
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedVersion?: InputMaybe<Scalars['Float']>;
  publishedVersion_exists?: InputMaybe<Scalars['Boolean']>;
  publishedVersion_gt?: InputMaybe<Scalars['Float']>;
  publishedVersion_gte?: InputMaybe<Scalars['Float']>;
  publishedVersion_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  publishedVersion_lt?: InputMaybe<Scalars['Float']>;
  publishedVersion_lte?: InputMaybe<Scalars['Float']>;
  publishedVersion_not?: InputMaybe<Scalars['Float']>;
  publishedVersion_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type CfCommisionNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfCommisionNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfCommisionNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']>;
  description_contains?: InputMaybe<Scalars['String']>;
  description_exists?: InputMaybe<Scalars['Boolean']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_not?: InputMaybe<Scalars['String']>;
  description_not_contains?: InputMaybe<Scalars['String']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  shortDescription?: InputMaybe<Scalars['String']>;
  shortDescription_contains?: InputMaybe<Scalars['String']>;
  shortDescription_exists?: InputMaybe<Scalars['Boolean']>;
  shortDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  shortDescription_not?: InputMaybe<Scalars['String']>;
  shortDescription_not_contains?: InputMaybe<Scalars['String']>;
  shortDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slug_contains?: InputMaybe<Scalars['String']>;
  slug_exists?: InputMaybe<Scalars['Boolean']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug_not?: InputMaybe<Scalars['String']>;
  slug_not_contains?: InputMaybe<Scalars['String']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfCommissionSeasonNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfCommissionSeasonNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfCommissionSeasonNestedFilter>>>;
  availablePasses?: InputMaybe<Scalars['Int']>;
  availablePasses_exists?: InputMaybe<Scalars['Boolean']>;
  availablePasses_gt?: InputMaybe<Scalars['Int']>;
  availablePasses_gte?: InputMaybe<Scalars['Int']>;
  availablePasses_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  availablePasses_lt?: InputMaybe<Scalars['Int']>;
  availablePasses_lte?: InputMaybe<Scalars['Int']>;
  availablePasses_not?: InputMaybe<Scalars['Int']>;
  availablePasses_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  commission_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  contractAddress?: InputMaybe<Scalars['String']>;
  contractAddress_contains?: InputMaybe<Scalars['String']>;
  contractAddress_exists?: InputMaybe<Scalars['Boolean']>;
  contractAddress_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contractAddress_not?: InputMaybe<Scalars['String']>;
  contractAddress_not_contains?: InputMaybe<Scalars['String']>;
  contractAddress_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  description_contains?: InputMaybe<Scalars['String']>;
  description_exists?: InputMaybe<Scalars['Boolean']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_not?: InputMaybe<Scalars['String']>;
  description_not_contains?: InputMaybe<Scalars['String']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  droptime?: InputMaybe<Scalars['DateTime']>;
  droptime_exists?: InputMaybe<Scalars['Boolean']>;
  droptime_gt?: InputMaybe<Scalars['DateTime']>;
  droptime_gte?: InputMaybe<Scalars['DateTime']>;
  droptime_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  droptime_lt?: InputMaybe<Scalars['DateTime']>;
  droptime_lte?: InputMaybe<Scalars['DateTime']>;
  droptime_not?: InputMaybe<Scalars['DateTime']>;
  droptime_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nftsPerPass?: InputMaybe<Scalars['Int']>;
  nftsPerPass_exists?: InputMaybe<Scalars['Boolean']>;
  nftsPerPass_gt?: InputMaybe<Scalars['Int']>;
  nftsPerPass_gte?: InputMaybe<Scalars['Int']>;
  nftsPerPass_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  nftsPerPass_lt?: InputMaybe<Scalars['Int']>;
  nftsPerPass_lte?: InputMaybe<Scalars['Int']>;
  nftsPerPass_not?: InputMaybe<Scalars['Int']>;
  nftsPerPass_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  passPrice?: InputMaybe<Scalars['Float']>;
  passPrice_exists?: InputMaybe<Scalars['Boolean']>;
  passPrice_gt?: InputMaybe<Scalars['Float']>;
  passPrice_gte?: InputMaybe<Scalars['Float']>;
  passPrice_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  passPrice_lt?: InputMaybe<Scalars['Float']>;
  passPrice_lte?: InputMaybe<Scalars['Float']>;
  passPrice_not?: InputMaybe<Scalars['Float']>;
  passPrice_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  seasonNumber?: InputMaybe<Scalars['Int']>;
  seasonNumber_exists?: InputMaybe<Scalars['Boolean']>;
  seasonNumber_gt?: InputMaybe<Scalars['Int']>;
  seasonNumber_gte?: InputMaybe<Scalars['Int']>;
  seasonNumber_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  seasonNumber_lt?: InputMaybe<Scalars['Int']>;
  seasonNumber_lte?: InputMaybe<Scalars['Int']>;
  seasonNumber_not?: InputMaybe<Scalars['Int']>;
  seasonNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slug_contains?: InputMaybe<Scalars['String']>;
  slug_exists?: InputMaybe<Scalars['Boolean']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug_not?: InputMaybe<Scalars['String']>;
  slug_not_contains?: InputMaybe<Scalars['String']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  totalPasses?: InputMaybe<Scalars['Int']>;
  totalPasses_exists?: InputMaybe<Scalars['Boolean']>;
  totalPasses_gt?: InputMaybe<Scalars['Int']>;
  totalPasses_gte?: InputMaybe<Scalars['Int']>;
  totalPasses_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  totalPasses_lt?: InputMaybe<Scalars['Int']>;
  totalPasses_lte?: InputMaybe<Scalars['Int']>;
  totalPasses_not?: InputMaybe<Scalars['Int']>;
  totalPasses_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type GetFooterQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFooterQuery = { __typename?: 'Query', homepage?: { __typename?: 'Homepage', footerBlurb?: string | null, footerLinksColumnOneCollection?: { __typename?: 'HomepageFooterLinksColumnOneCollection', items: Array<{ __typename?: 'Link', label?: string | null, url?: string | null } | null> } | null, footerLinksColumnTwoCollection?: { __typename?: 'HomepageFooterLinksColumnTwoCollection', items: Array<{ __typename?: 'Link', label?: string | null, url?: string | null } | null> } | null } | null };

export type GetHeaderCommissionTiersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHeaderCommissionTiersQuery = { __typename?: 'Query', commisionCollection?: { __typename?: 'CommisionCollection', items: Array<{ __typename?: 'Commision', slug?: string | null, name?: string | null, description?: string | null } | null> } | null };

export type GetRecentCollectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRecentCollectionsQuery = { __typename?: 'Query', collectionCollection?: { __typename?: 'CollectionCollection', items: Array<{ __typename?: 'Collection', slug?: string | null, projectName?: string | null, name?: string | null, image?: { __typename?: 'Asset', url?: string | null } | null, season?: { __typename?: 'CommissionSeason', commission?: { __typename?: 'Commision', slug?: string | null } | null } | null } | null> } | null };

export type ArtistCollectionFragment = { __typename?: 'Collection', slug?: string | null, id?: number | null, name?: string | null, projectName?: string | null, projectDescription?: string | null, tokenIdStart?: number | null, tokenIdEnd?: number | null, etherscan?: string | null, opensea?: string | null, cid?: string | null, type?: string | null, droptime?: any | null, season?: { __typename?: 'CommissionSeason', seasonNumber?: number | null, commission?: { __typename?: 'Commision', slug?: string | null, name?: string | null } | null } | null, image?: { __typename?: 'Asset', url?: string | null } | null };

export type GetAboutPageQueryVariables = Exact<{
  preview?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetAboutPageQuery = { __typename?: 'Query', about?: { __typename?: 'About', headline?: string | null, cta1SubCopy?: string | null, collectionLinksCta?: string | null, cta3?: string | null, collectionLinksCollection?: { __typename?: 'AboutCollectionLinksCollection', items: Array<{ __typename?: 'Link', label?: string | null, url?: string | null } | null> } | null, faqCollection?: { __typename?: 'AboutFaqCollection', items: Array<{ __typename?: 'Faq', question?: string | null, answer?: string | null } | null> } | null } | null };

export type GetSlugFromIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetSlugFromIdQuery = { __typename?: 'Query', commision?: { __typename?: 'Commision', slug?: string | null } | null };

export type GetPastCollectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPastCollectionsQuery = { __typename?: 'Query', commissionSeasonCollection?: { __typename?: 'CommissionSeasonCollection', items: Array<{ __typename?: 'CommissionSeason', slug?: string | null, description?: string | null, name?: string | null, seasonNumber?: number | null, droptime?: any | null } | null> } | null, communityCollections?: { __typename?: 'CollectionCollection', items: Array<{ __typename?: 'Collection', droptime?: any | null, image?: { __typename?: 'Asset', url?: string | null } | null, season?: { __typename?: 'CommissionSeason', seasonNumber?: number | null } | null } | null> } | null, collectionCollection?: { __typename?: 'CollectionCollection', items: Array<{ __typename?: 'Collection', slug?: string | null, projectDescription?: string | null, name?: string | null, projectName?: string | null, droptime?: any | null, image?: { __typename?: 'Asset', url?: string | null } | null, season?: { __typename?: 'CommissionSeason', seasonNumber?: number | null, commission?: { __typename?: 'Commision', slug?: string | null, name?: string | null } | null } | null } | null> } | null };

export type GetImageCollectionGalleryQueryVariables = Exact<{
  slug: Scalars['String'];
  preview?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetImageCollectionGalleryQuery = { __typename?: 'Query', collectionCollection?: { __typename?: 'CollectionCollection', items: Array<{ __typename?: 'Collection', slug?: string | null, id?: number | null, name?: string | null, projectName?: string | null, projectDescription?: string | null, tokenIdStart?: number | null, tokenIdEnd?: number | null, etherscan?: string | null, opensea?: string | null, cid?: string | null, type?: string | null, droptime?: any | null, season?: { __typename?: 'CommissionSeason', seasonNumber?: number | null, commission?: { __typename?: 'Commision', slug?: string | null, name?: string | null } | null } | null, image?: { __typename?: 'Asset', url?: string | null } | null } | null> } | null };

export type GetArtistCollectionQueryVariables = Exact<{
  slug: Scalars['String'];
  preview?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetArtistCollectionQuery = { __typename?: 'Query', collectionCollection?: { __typename?: 'CollectionCollection', items: Array<{ __typename?: 'Collection', slug?: string | null, id?: number | null, name?: string | null, projectName?: string | null, projectDescription?: string | null, tokenIdStart?: number | null, tokenIdEnd?: number | null, etherscan?: string | null, opensea?: string | null, cid?: string | null, type?: string | null, droptime?: any | null, season?: { __typename?: 'CommissionSeason', seasonNumber?: number | null, commission?: { __typename?: 'Commision', slug?: string | null, name?: string | null } | null } | null, image?: { __typename?: 'Asset', url?: string | null } | null } | null> } | null };

export type GetCollectionSlugsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCollectionSlugsQuery = { __typename?: 'Query', collectionCollection?: { __typename?: 'CollectionCollection', items: Array<{ __typename?: 'Collection', slug?: string | null } | null> } | null };

export type GetCollectorsPageQueryVariables = Exact<{
  preview?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetCollectorsPageQuery = { __typename?: 'Query', collectors?: { __typename?: 'Collectors', headline?: string | null, cta1SubCopy?: string | null } | null };

export type GetCommissionTierBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
  preview?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetCommissionTierBySlugQuery = { __typename?: 'Query', commisionCollection?: { __typename?: 'CommisionCollection', items: Array<{ __typename?: 'Commision', slug?: string | null, name?: string | null, description?: string | null } | null> } | null, commissionSeasonCollection?: { __typename?: 'CommissionSeasonCollection', items: Array<{ __typename?: 'CommissionSeason', slug?: string | null, name?: string | null, description?: string | null, seasonNumber?: number | null } | null> } | null, collectionCollection?: { __typename?: 'CollectionCollection', items: Array<{ __typename?: 'Collection', slug?: string | null, projectDescription?: string | null, projectName?: string | null, name?: string | null, type?: string | null, image?: { __typename?: 'Asset', url?: string | null } | null, season?: { __typename?: 'CommissionSeason', seasonNumber?: number | null } | null } | null> } | null };

export type GetCommissionSeasonByNumberQueryVariables = Exact<{
  slug: Scalars['String'];
  seasonNumber: Scalars['Int'];
  preview?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetCommissionSeasonByNumberQuery = { __typename?: 'Query', commissionSeasonCollection?: { __typename?: 'CommissionSeasonCollection', items: Array<{ __typename?: 'CommissionSeason', slug?: string | null, seasonNumber?: number | null, name?: string | null, totalPasses?: number | null, passPrice?: number | null, nftsPerPass?: number | null, availablePasses?: number | null, commission?: { __typename?: 'Commision', slug?: string | null, name?: string | null, description?: string | null } | null } | null> } | null, collectionCollection?: { __typename?: 'CollectionCollection', items: Array<{ __typename?: 'Collection', slug?: string | null, name?: string | null, projectName?: string | null, projectDescription?: string | null, image?: { __typename?: 'Asset', url?: string | null } | null } | null> } | null };

export type GetCommunityCommissionDropQueryVariables = Exact<{
  commission: Scalars['String'];
  season: Scalars['Int'];
}>;


export type GetCommunityCommissionDropQuery = { __typename?: 'Query', collectionCollection?: { __typename?: 'CollectionCollection', items: Array<{ __typename?: 'Collection', name?: string | null, slug?: string | null, cid?: string | null, id?: number | null, tokenIdStart?: number | null, tokenIdEnd?: number | null } | null> } | null, commissionSeasonCollection?: { __typename?: 'CommissionSeasonCollection', items: Array<{ __typename?: 'CommissionSeason', name?: string | null, description?: string | null } | null> } | null };

export type GetCommunityProjectBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetCommunityProjectBySlugQuery = { __typename?: 'Query', communityProjectsCollection?: { __typename?: 'CommunityProjectsCollection', items: Array<{ __typename?: 'CommunityProjects', slug?: string | null, link?: string | null } | null> } | null };

export type GetCommunityProjectPageQueryVariables = Exact<{
  preview?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetCommunityProjectPageQuery = { __typename?: 'Query', communityProjectsPage?: { __typename?: 'CommunityProjectsPage', description?: string | null } | null, communityProjectsCollection?: { __typename?: 'CommunityProjectsCollection', items: Array<{ __typename?: 'CommunityProjects', name?: string | null, slug?: string | null, description?: string | null, image?: { __typename?: 'Asset', url?: string | null } | null } | null> } | null };

export type GetHomePageQueryVariables = Exact<{
  preview?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetHomePageQuery = { __typename?: 'Query', homepage?: { __typename?: 'Homepage', headline?: string | null, cta2?: string | null, cta2SubCopy?: string | null, statsHeader?: string | null, cta3?: string | null, cta3SubCopy?: string | null, isAnnouncementVisible?: boolean | null, announcementCta?: string | null, announcementCtaLink?: string | null, announcementCtaSubCopy?: string | null, annonuncementCtaButtonText?: string | null, statsCollection?: { __typename?: 'HomepageStatsCollection', items: Array<{ __typename?: 'ContentBlock', title?: string | null, description?: string | null } | null> } | null, featuredCollectionsCollection?: { __typename?: 'HomepageFeaturedCollectionsCollection', items: Array<{ __typename?: 'Collection', slug?: string | null, name?: string | null, projectName?: string | null, type?: string | null, image?: { __typename?: 'Asset', url?: string | null } | null, season?: { __typename?: 'CommissionSeason', commission?: { __typename?: 'Commision', slug?: string | null, name?: string | null } | null } | null } | null> } | null } | null, commisionCollection?: { __typename?: 'CommisionCollection', items: Array<{ __typename?: 'Commision', slug?: string | null, name?: string | null, description?: string | null } | null> } | null, collectionCollection?: { __typename?: 'CollectionCollection', items: Array<{ __typename?: 'Collection', slug?: string | null, name?: string | null, projectName?: string | null, type?: string | null, image?: { __typename?: 'Asset', url?: string | null } | null, season?: { __typename?: 'CommissionSeason', commission?: { __typename?: 'Commision', slug?: string | null, name?: string | null } | null } | null } | null> } | null };

export type HomepageCollectionsFragment = { __typename?: 'Collection', slug?: string | null, name?: string | null, projectName?: string | null, type?: string | null, image?: { __typename?: 'Asset', url?: string | null } | null, season?: { __typename?: 'CommissionSeason', commission?: { __typename?: 'Commision', slug?: string | null, name?: string | null } | null } | null };

export type GetCommissionProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCommissionProjectsQuery = { __typename?: 'Query', collectionCollection?: { __typename?: 'CollectionCollection', items: Array<{ __typename?: 'Collection', id?: number | null, name?: string | null, slug?: string | null, projectName?: string | null, commission?: { __typename?: 'Commision', slug?: string | null } | null } | null> } | null };

export type GetHowItWorksPageQueryVariables = Exact<{
  preview?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetHowItWorksPageQuery = { __typename?: 'Query', howItWorks?: { __typename?: 'HowItWorks', headline?: string | null, faqCollection?: { __typename?: 'HowItWorksFaqCollection', items: Array<{ __typename?: 'Faq', question?: string | null, answer?: string | null } | null> } | null } | null };

export type GetCollectionsListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCollectionsListQuery = { __typename?: 'Query', collectionCollection?: { __typename?: 'CollectionCollection', items: Array<{ __typename?: 'Collection', slug?: string | null, name?: string | null, projectName?: string | null, droptime?: any | null, season?: { __typename?: 'CommissionSeason', commission?: { __typename?: 'Commision', slug?: string | null, name?: string | null } | null } | null } | null> } | null, communityProjectsPage?: { __typename?: 'CommunityProjectsPage', shortDescription?: string | null } | null, communityProjectsCollection?: { __typename?: 'CommunityProjectsCollection', items: Array<{ __typename?: 'CommunityProjects', name?: string | null, slug?: string | null } | null> } | null, commisionCollection?: { __typename?: 'CommisionCollection', items: Array<{ __typename?: 'Commision', slug?: string | null, name?: string | null, shortDescription?: string | null, description?: string | null } | null> } | null };

export const ArtistCollectionFragmentDoc = gql`
    fragment artistCollection on Collection {
  slug
  id
  name
  projectName
  projectDescription
  tokenIdStart
  tokenIdEnd
  etherscan
  opensea
  cid
  type
  droptime
  season {
    seasonNumber
    commission {
      slug
      name
    }
  }
  image {
    url
  }
}
    `;
export const HomepageCollectionsFragmentDoc = gql`
    fragment homepageCollections on Collection {
  slug
  name
  projectName
  image {
    url
  }
  type
  season {
    commission {
      slug
      name
    }
  }
}
    `;
export const GetFooterDocument = gql`
    query GetFooter {
  homepage(id: "") {
    footerBlurb
    footerLinksColumnOneCollection {
      items {
        label
        url
      }
    }
    footerLinksColumnTwoCollection {
      items {
        label
        url
      }
    }
  }
}
    `;

/**
 * __useGetFooterQuery__
 *
 * To run a query within a React component, call `useGetFooterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFooterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFooterQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFooterQuery(baseOptions?: Apollo.QueryHookOptions<GetFooterQuery, GetFooterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFooterQuery, GetFooterQueryVariables>(GetFooterDocument, options);
      }
export function useGetFooterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFooterQuery, GetFooterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFooterQuery, GetFooterQueryVariables>(GetFooterDocument, options);
        }
export type GetFooterQueryHookResult = ReturnType<typeof useGetFooterQuery>;
export type GetFooterLazyQueryHookResult = ReturnType<typeof useGetFooterLazyQuery>;
export type GetFooterQueryResult = Apollo.QueryResult<GetFooterQuery, GetFooterQueryVariables>;
export const GetHeaderCommissionTiersDocument = gql`
    query GetHeaderCommissionTiers {
  commisionCollection {
    items {
      slug
      name
      description
    }
  }
}
    `;

/**
 * __useGetHeaderCommissionTiersQuery__
 *
 * To run a query within a React component, call `useGetHeaderCommissionTiersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHeaderCommissionTiersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHeaderCommissionTiersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHeaderCommissionTiersQuery(baseOptions?: Apollo.QueryHookOptions<GetHeaderCommissionTiersQuery, GetHeaderCommissionTiersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHeaderCommissionTiersQuery, GetHeaderCommissionTiersQueryVariables>(GetHeaderCommissionTiersDocument, options);
      }
export function useGetHeaderCommissionTiersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHeaderCommissionTiersQuery, GetHeaderCommissionTiersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHeaderCommissionTiersQuery, GetHeaderCommissionTiersQueryVariables>(GetHeaderCommissionTiersDocument, options);
        }
export type GetHeaderCommissionTiersQueryHookResult = ReturnType<typeof useGetHeaderCommissionTiersQuery>;
export type GetHeaderCommissionTiersLazyQueryHookResult = ReturnType<typeof useGetHeaderCommissionTiersLazyQuery>;
export type GetHeaderCommissionTiersQueryResult = Apollo.QueryResult<GetHeaderCommissionTiersQuery, GetHeaderCommissionTiersQueryVariables>;
export const GetRecentCollectionsDocument = gql`
    query GetRecentCollections {
  collectionCollection(limit: 5, order: droptime_DESC) {
    items {
      image {
        url
      }
      slug
      projectName
      name
      season {
        commission {
          slug
        }
      }
    }
  }
}
    `;

/**
 * __useGetRecentCollectionsQuery__
 *
 * To run a query within a React component, call `useGetRecentCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentCollectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRecentCollectionsQuery(baseOptions?: Apollo.QueryHookOptions<GetRecentCollectionsQuery, GetRecentCollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentCollectionsQuery, GetRecentCollectionsQueryVariables>(GetRecentCollectionsDocument, options);
      }
export function useGetRecentCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentCollectionsQuery, GetRecentCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentCollectionsQuery, GetRecentCollectionsQueryVariables>(GetRecentCollectionsDocument, options);
        }
export type GetRecentCollectionsQueryHookResult = ReturnType<typeof useGetRecentCollectionsQuery>;
export type GetRecentCollectionsLazyQueryHookResult = ReturnType<typeof useGetRecentCollectionsLazyQuery>;
export type GetRecentCollectionsQueryResult = Apollo.QueryResult<GetRecentCollectionsQuery, GetRecentCollectionsQueryVariables>;
export const GetAboutPageDocument = gql`
    query GetAboutPage($preview: Boolean) {
  about(id: "2QTcmiocnFnoYThe4WMjU2", preview: $preview) {
    headline
    cta1SubCopy
    collectionLinksCta
    collectionLinksCollection {
      items {
        label
        url
      }
    }
    cta3
    faqCollection {
      items {
        question
        answer
      }
    }
  }
}
    `;

/**
 * __useGetAboutPageQuery__
 *
 * To run a query within a React component, call `useGetAboutPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAboutPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAboutPageQuery({
 *   variables: {
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useGetAboutPageQuery(baseOptions?: Apollo.QueryHookOptions<GetAboutPageQuery, GetAboutPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAboutPageQuery, GetAboutPageQueryVariables>(GetAboutPageDocument, options);
      }
export function useGetAboutPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAboutPageQuery, GetAboutPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAboutPageQuery, GetAboutPageQueryVariables>(GetAboutPageDocument, options);
        }
export type GetAboutPageQueryHookResult = ReturnType<typeof useGetAboutPageQuery>;
export type GetAboutPageLazyQueryHookResult = ReturnType<typeof useGetAboutPageLazyQuery>;
export type GetAboutPageQueryResult = Apollo.QueryResult<GetAboutPageQuery, GetAboutPageQueryVariables>;
export const GetSlugFromIdDocument = gql`
    query getSlugFromId($id: String!) {
  commision(id: $id) {
    slug
  }
}
    `;

/**
 * __useGetSlugFromIdQuery__
 *
 * To run a query within a React component, call `useGetSlugFromIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSlugFromIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSlugFromIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSlugFromIdQuery(baseOptions: Apollo.QueryHookOptions<GetSlugFromIdQuery, GetSlugFromIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSlugFromIdQuery, GetSlugFromIdQueryVariables>(GetSlugFromIdDocument, options);
      }
export function useGetSlugFromIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSlugFromIdQuery, GetSlugFromIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSlugFromIdQuery, GetSlugFromIdQueryVariables>(GetSlugFromIdDocument, options);
        }
export type GetSlugFromIdQueryHookResult = ReturnType<typeof useGetSlugFromIdQuery>;
export type GetSlugFromIdLazyQueryHookResult = ReturnType<typeof useGetSlugFromIdLazyQuery>;
export type GetSlugFromIdQueryResult = Apollo.QueryResult<GetSlugFromIdQuery, GetSlugFromIdQueryVariables>;
export const GetPastCollectionsDocument = gql`
    query GetPastCollections {
  commissionSeasonCollection(where: {commission: {slug: "community"}}) {
    items {
      slug
      description
      name
      seasonNumber
      droptime
    }
  }
  communityCollections: collectionCollection(
    order: droptime_DESC
    where: {commission: {slug: "community"}}
  ) {
    items {
      droptime
      image {
        url
      }
      season {
        seasonNumber
      }
    }
  }
  collectionCollection(
    order: droptime_DESC
    where: {commission: {slug_not: "community"}, image_exists: true}
  ) {
    items {
      slug
      projectDescription
      name
      projectName
      droptime
      image {
        url
      }
      season {
        seasonNumber
        commission {
          slug
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetPastCollectionsQuery__
 *
 * To run a query within a React component, call `useGetPastCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPastCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPastCollectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPastCollectionsQuery(baseOptions?: Apollo.QueryHookOptions<GetPastCollectionsQuery, GetPastCollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPastCollectionsQuery, GetPastCollectionsQueryVariables>(GetPastCollectionsDocument, options);
      }
export function useGetPastCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPastCollectionsQuery, GetPastCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPastCollectionsQuery, GetPastCollectionsQueryVariables>(GetPastCollectionsDocument, options);
        }
export type GetPastCollectionsQueryHookResult = ReturnType<typeof useGetPastCollectionsQuery>;
export type GetPastCollectionsLazyQueryHookResult = ReturnType<typeof useGetPastCollectionsLazyQuery>;
export type GetPastCollectionsQueryResult = Apollo.QueryResult<GetPastCollectionsQuery, GetPastCollectionsQueryVariables>;
export const GetImageCollectionGalleryDocument = gql`
    query GetImageCollectionGallery($slug: String!, $preview: Boolean) {
  collectionCollection(where: {slug: $slug}, preview: $preview) {
    items {
      ...artistCollection
    }
  }
}
    ${ArtistCollectionFragmentDoc}`;

/**
 * __useGetImageCollectionGalleryQuery__
 *
 * To run a query within a React component, call `useGetImageCollectionGalleryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImageCollectionGalleryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImageCollectionGalleryQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useGetImageCollectionGalleryQuery(baseOptions: Apollo.QueryHookOptions<GetImageCollectionGalleryQuery, GetImageCollectionGalleryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetImageCollectionGalleryQuery, GetImageCollectionGalleryQueryVariables>(GetImageCollectionGalleryDocument, options);
      }
export function useGetImageCollectionGalleryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetImageCollectionGalleryQuery, GetImageCollectionGalleryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetImageCollectionGalleryQuery, GetImageCollectionGalleryQueryVariables>(GetImageCollectionGalleryDocument, options);
        }
export type GetImageCollectionGalleryQueryHookResult = ReturnType<typeof useGetImageCollectionGalleryQuery>;
export type GetImageCollectionGalleryLazyQueryHookResult = ReturnType<typeof useGetImageCollectionGalleryLazyQuery>;
export type GetImageCollectionGalleryQueryResult = Apollo.QueryResult<GetImageCollectionGalleryQuery, GetImageCollectionGalleryQueryVariables>;
export const GetArtistCollectionDocument = gql`
    query GetArtistCollection($slug: String!, $preview: Boolean) {
  collectionCollection(where: {slug: $slug}, preview: $preview) {
    items {
      ...artistCollection
    }
  }
}
    ${ArtistCollectionFragmentDoc}`;

/**
 * __useGetArtistCollectionQuery__
 *
 * To run a query within a React component, call `useGetArtistCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArtistCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArtistCollectionQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useGetArtistCollectionQuery(baseOptions: Apollo.QueryHookOptions<GetArtistCollectionQuery, GetArtistCollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArtistCollectionQuery, GetArtistCollectionQueryVariables>(GetArtistCollectionDocument, options);
      }
export function useGetArtistCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArtistCollectionQuery, GetArtistCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArtistCollectionQuery, GetArtistCollectionQueryVariables>(GetArtistCollectionDocument, options);
        }
export type GetArtistCollectionQueryHookResult = ReturnType<typeof useGetArtistCollectionQuery>;
export type GetArtistCollectionLazyQueryHookResult = ReturnType<typeof useGetArtistCollectionLazyQuery>;
export type GetArtistCollectionQueryResult = Apollo.QueryResult<GetArtistCollectionQuery, GetArtistCollectionQueryVariables>;
export const GetCollectionSlugsDocument = gql`
    query GetCollectionSlugs {
  collectionCollection {
    items {
      slug
    }
  }
}
    `;

/**
 * __useGetCollectionSlugsQuery__
 *
 * To run a query within a React component, call `useGetCollectionSlugsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionSlugsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionSlugsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCollectionSlugsQuery(baseOptions?: Apollo.QueryHookOptions<GetCollectionSlugsQuery, GetCollectionSlugsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionSlugsQuery, GetCollectionSlugsQueryVariables>(GetCollectionSlugsDocument, options);
      }
export function useGetCollectionSlugsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionSlugsQuery, GetCollectionSlugsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionSlugsQuery, GetCollectionSlugsQueryVariables>(GetCollectionSlugsDocument, options);
        }
export type GetCollectionSlugsQueryHookResult = ReturnType<typeof useGetCollectionSlugsQuery>;
export type GetCollectionSlugsLazyQueryHookResult = ReturnType<typeof useGetCollectionSlugsLazyQuery>;
export type GetCollectionSlugsQueryResult = Apollo.QueryResult<GetCollectionSlugsQuery, GetCollectionSlugsQueryVariables>;
export const GetCollectorsPageDocument = gql`
    query GetCollectorsPage($preview: Boolean) {
  collectors(id: "", preview: $preview) {
    headline
    cta1SubCopy
  }
}
    `;

/**
 * __useGetCollectorsPageQuery__
 *
 * To run a query within a React component, call `useGetCollectorsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectorsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectorsPageQuery({
 *   variables: {
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useGetCollectorsPageQuery(baseOptions?: Apollo.QueryHookOptions<GetCollectorsPageQuery, GetCollectorsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectorsPageQuery, GetCollectorsPageQueryVariables>(GetCollectorsPageDocument, options);
      }
export function useGetCollectorsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectorsPageQuery, GetCollectorsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectorsPageQuery, GetCollectorsPageQueryVariables>(GetCollectorsPageDocument, options);
        }
export type GetCollectorsPageQueryHookResult = ReturnType<typeof useGetCollectorsPageQuery>;
export type GetCollectorsPageLazyQueryHookResult = ReturnType<typeof useGetCollectorsPageLazyQuery>;
export type GetCollectorsPageQueryResult = Apollo.QueryResult<GetCollectorsPageQuery, GetCollectorsPageQueryVariables>;
export const GetCommissionTierBySlugDocument = gql`
    query GetCommissionTierBySlug($slug: String!, $preview: Boolean) {
  commisionCollection(where: {slug_contains: $slug}, preview: $preview) {
    items {
      slug
      name
      description
    }
  }
  commissionSeasonCollection(
    where: {commission: {slug_contains: $slug}}
    order: seasonNumber_DESC
    preview: $preview
  ) {
    items {
      slug
      name
      description
      name
      seasonNumber
    }
  }
  collectionCollection(
    where: {commission: {slug_contains: $slug}, image_exists: true}
    order: id_DESC
    preview: $preview
  ) {
    items {
      slug
      projectDescription
      projectName
      name
      type
      image {
        url
      }
      season {
        seasonNumber
      }
    }
  }
}
    `;

/**
 * __useGetCommissionTierBySlugQuery__
 *
 * To run a query within a React component, call `useGetCommissionTierBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommissionTierBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommissionTierBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useGetCommissionTierBySlugQuery(baseOptions: Apollo.QueryHookOptions<GetCommissionTierBySlugQuery, GetCommissionTierBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommissionTierBySlugQuery, GetCommissionTierBySlugQueryVariables>(GetCommissionTierBySlugDocument, options);
      }
export function useGetCommissionTierBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommissionTierBySlugQuery, GetCommissionTierBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommissionTierBySlugQuery, GetCommissionTierBySlugQueryVariables>(GetCommissionTierBySlugDocument, options);
        }
export type GetCommissionTierBySlugQueryHookResult = ReturnType<typeof useGetCommissionTierBySlugQuery>;
export type GetCommissionTierBySlugLazyQueryHookResult = ReturnType<typeof useGetCommissionTierBySlugLazyQuery>;
export type GetCommissionTierBySlugQueryResult = Apollo.QueryResult<GetCommissionTierBySlugQuery, GetCommissionTierBySlugQueryVariables>;
export const GetCommissionSeasonByNumberDocument = gql`
    query GetCommissionSeasonByNumber($slug: String!, $seasonNumber: Int!, $preview: Boolean) {
  commissionSeasonCollection(
    preview: $preview
    limit: 1
    where: {seasonNumber: $seasonNumber, commission: {slug_contains: $slug}}
  ) {
    items {
      slug
      seasonNumber
      slug
      name
      totalPasses
      passPrice
      nftsPerPass
      availablePasses
      commission {
        slug
        name
        description
      }
    }
  }
  collectionCollection(preview: $preview, where: {commission: {slug: $slug}}) {
    items {
      slug
      name
      projectName
      projectDescription
      image {
        url
      }
    }
  }
}
    `;

/**
 * __useGetCommissionSeasonByNumberQuery__
 *
 * To run a query within a React component, call `useGetCommissionSeasonByNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommissionSeasonByNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommissionSeasonByNumberQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      seasonNumber: // value for 'seasonNumber'
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useGetCommissionSeasonByNumberQuery(baseOptions: Apollo.QueryHookOptions<GetCommissionSeasonByNumberQuery, GetCommissionSeasonByNumberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommissionSeasonByNumberQuery, GetCommissionSeasonByNumberQueryVariables>(GetCommissionSeasonByNumberDocument, options);
      }
export function useGetCommissionSeasonByNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommissionSeasonByNumberQuery, GetCommissionSeasonByNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommissionSeasonByNumberQuery, GetCommissionSeasonByNumberQueryVariables>(GetCommissionSeasonByNumberDocument, options);
        }
export type GetCommissionSeasonByNumberQueryHookResult = ReturnType<typeof useGetCommissionSeasonByNumberQuery>;
export type GetCommissionSeasonByNumberLazyQueryHookResult = ReturnType<typeof useGetCommissionSeasonByNumberLazyQuery>;
export type GetCommissionSeasonByNumberQueryResult = Apollo.QueryResult<GetCommissionSeasonByNumberQuery, GetCommissionSeasonByNumberQueryVariables>;
export const GetCommunityCommissionDropDocument = gql`
    query GetCommunityCommissionDrop($commission: String!, $season: Int!) {
  collectionCollection(
    where: {season: {seasonNumber: $season}, commission: {slug: $commission}}
  ) {
    items {
      name
      slug
      cid
      id
      tokenIdStart
      tokenIdEnd
    }
  }
  commissionSeasonCollection(
    where: {seasonNumber: $season, commission: {slug: $commission}}
  ) {
    items {
      name
      description
    }
  }
}
    `;

/**
 * __useGetCommunityCommissionDropQuery__
 *
 * To run a query within a React component, call `useGetCommunityCommissionDropQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityCommissionDropQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityCommissionDropQuery({
 *   variables: {
 *      commission: // value for 'commission'
 *      season: // value for 'season'
 *   },
 * });
 */
export function useGetCommunityCommissionDropQuery(baseOptions: Apollo.QueryHookOptions<GetCommunityCommissionDropQuery, GetCommunityCommissionDropQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommunityCommissionDropQuery, GetCommunityCommissionDropQueryVariables>(GetCommunityCommissionDropDocument, options);
      }
export function useGetCommunityCommissionDropLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommunityCommissionDropQuery, GetCommunityCommissionDropQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommunityCommissionDropQuery, GetCommunityCommissionDropQueryVariables>(GetCommunityCommissionDropDocument, options);
        }
export type GetCommunityCommissionDropQueryHookResult = ReturnType<typeof useGetCommunityCommissionDropQuery>;
export type GetCommunityCommissionDropLazyQueryHookResult = ReturnType<typeof useGetCommunityCommissionDropLazyQuery>;
export type GetCommunityCommissionDropQueryResult = Apollo.QueryResult<GetCommunityCommissionDropQuery, GetCommunityCommissionDropQueryVariables>;
export const GetCommunityProjectBySlugDocument = gql`
    query GetCommunityProjectBySlug($slug: String!) {
  communityProjectsCollection(where: {slug: $slug}) {
    items {
      slug
      link
    }
  }
}
    `;

/**
 * __useGetCommunityProjectBySlugQuery__
 *
 * To run a query within a React component, call `useGetCommunityProjectBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityProjectBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityProjectBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetCommunityProjectBySlugQuery(baseOptions: Apollo.QueryHookOptions<GetCommunityProjectBySlugQuery, GetCommunityProjectBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommunityProjectBySlugQuery, GetCommunityProjectBySlugQueryVariables>(GetCommunityProjectBySlugDocument, options);
      }
export function useGetCommunityProjectBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommunityProjectBySlugQuery, GetCommunityProjectBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommunityProjectBySlugQuery, GetCommunityProjectBySlugQueryVariables>(GetCommunityProjectBySlugDocument, options);
        }
export type GetCommunityProjectBySlugQueryHookResult = ReturnType<typeof useGetCommunityProjectBySlugQuery>;
export type GetCommunityProjectBySlugLazyQueryHookResult = ReturnType<typeof useGetCommunityProjectBySlugLazyQuery>;
export type GetCommunityProjectBySlugQueryResult = Apollo.QueryResult<GetCommunityProjectBySlugQuery, GetCommunityProjectBySlugQueryVariables>;
export const GetCommunityProjectPageDocument = gql`
    query GetCommunityProjectPage($preview: Boolean) {
  communityProjectsPage(id: "", preview: $preview) {
    description
  }
  communityProjectsCollection(order: order_ASC) {
    items {
      name
      slug
      description
      image {
        url
      }
    }
  }
}
    `;

/**
 * __useGetCommunityProjectPageQuery__
 *
 * To run a query within a React component, call `useGetCommunityProjectPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityProjectPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityProjectPageQuery({
 *   variables: {
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useGetCommunityProjectPageQuery(baseOptions?: Apollo.QueryHookOptions<GetCommunityProjectPageQuery, GetCommunityProjectPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommunityProjectPageQuery, GetCommunityProjectPageQueryVariables>(GetCommunityProjectPageDocument, options);
      }
export function useGetCommunityProjectPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommunityProjectPageQuery, GetCommunityProjectPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommunityProjectPageQuery, GetCommunityProjectPageQueryVariables>(GetCommunityProjectPageDocument, options);
        }
export type GetCommunityProjectPageQueryHookResult = ReturnType<typeof useGetCommunityProjectPageQuery>;
export type GetCommunityProjectPageLazyQueryHookResult = ReturnType<typeof useGetCommunityProjectPageLazyQuery>;
export type GetCommunityProjectPageQueryResult = Apollo.QueryResult<GetCommunityProjectPageQuery, GetCommunityProjectPageQueryVariables>;
export const GetHomePageDocument = gql`
    query GetHomePage($preview: Boolean) {
  homepage(id: "", preview: $preview) {
    headline
    cta2
    cta2SubCopy
    statsHeader
    statsCollection {
      items {
        title
        description
      }
    }
    cta3
    cta3SubCopy
    isAnnouncementVisible
    announcementCta
    announcementCtaLink
    announcementCtaSubCopy
    annonuncementCtaButtonText
    featuredCollectionsCollection {
      items {
        ...homepageCollections
      }
    }
  }
  commisionCollection {
    items {
      slug
      name
      description
    }
  }
  collectionCollection(order: droptime_DESC) {
    items {
      ...homepageCollections
    }
  }
}
    ${HomepageCollectionsFragmentDoc}`;

/**
 * __useGetHomePageQuery__
 *
 * To run a query within a React component, call `useGetHomePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomePageQuery({
 *   variables: {
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useGetHomePageQuery(baseOptions?: Apollo.QueryHookOptions<GetHomePageQuery, GetHomePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHomePageQuery, GetHomePageQueryVariables>(GetHomePageDocument, options);
      }
export function useGetHomePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHomePageQuery, GetHomePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHomePageQuery, GetHomePageQueryVariables>(GetHomePageDocument, options);
        }
export type GetHomePageQueryHookResult = ReturnType<typeof useGetHomePageQuery>;
export type GetHomePageLazyQueryHookResult = ReturnType<typeof useGetHomePageLazyQuery>;
export type GetHomePageQueryResult = Apollo.QueryResult<GetHomePageQuery, GetHomePageQueryVariables>;
export const GetCommissionProjectsDocument = gql`
    query GetCommissionProjects {
  collectionCollection(
    where: {droptime_exists: true, OR: [{commission: {slug_contains: "curated"}}, {commission: {slug_contains: "magnum"}}]}
  ) {
    items {
      id
      name
      slug
      projectName
      commission {
        slug
      }
    }
  }
}
    `;

/**
 * __useGetCommissionProjectsQuery__
 *
 * To run a query within a React component, call `useGetCommissionProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommissionProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommissionProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCommissionProjectsQuery(baseOptions?: Apollo.QueryHookOptions<GetCommissionProjectsQuery, GetCommissionProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommissionProjectsQuery, GetCommissionProjectsQueryVariables>(GetCommissionProjectsDocument, options);
      }
export function useGetCommissionProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommissionProjectsQuery, GetCommissionProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommissionProjectsQuery, GetCommissionProjectsQueryVariables>(GetCommissionProjectsDocument, options);
        }
export type GetCommissionProjectsQueryHookResult = ReturnType<typeof useGetCommissionProjectsQuery>;
export type GetCommissionProjectsLazyQueryHookResult = ReturnType<typeof useGetCommissionProjectsLazyQuery>;
export type GetCommissionProjectsQueryResult = Apollo.QueryResult<GetCommissionProjectsQuery, GetCommissionProjectsQueryVariables>;
export const GetHowItWorksPageDocument = gql`
    query GetHowItWorksPage($preview: Boolean) {
  howItWorks(id: "", preview: $preview) {
    headline
    faqCollection {
      items {
        question
        answer
      }
    }
  }
}
    `;

/**
 * __useGetHowItWorksPageQuery__
 *
 * To run a query within a React component, call `useGetHowItWorksPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHowItWorksPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHowItWorksPageQuery({
 *   variables: {
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useGetHowItWorksPageQuery(baseOptions?: Apollo.QueryHookOptions<GetHowItWorksPageQuery, GetHowItWorksPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHowItWorksPageQuery, GetHowItWorksPageQueryVariables>(GetHowItWorksPageDocument, options);
      }
export function useGetHowItWorksPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHowItWorksPageQuery, GetHowItWorksPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHowItWorksPageQuery, GetHowItWorksPageQueryVariables>(GetHowItWorksPageDocument, options);
        }
export type GetHowItWorksPageQueryHookResult = ReturnType<typeof useGetHowItWorksPageQuery>;
export type GetHowItWorksPageLazyQueryHookResult = ReturnType<typeof useGetHowItWorksPageLazyQuery>;
export type GetHowItWorksPageQueryResult = Apollo.QueryResult<GetHowItWorksPageQuery, GetHowItWorksPageQueryVariables>;
export const GetCollectionsListDocument = gql`
    query GetCollectionsList {
  collectionCollection(order: droptime_ASC) {
    items {
      slug
      name
      projectName
      droptime
      season {
        commission {
          slug
          name
        }
      }
    }
  }
  communityProjectsPage(id: "1PHtHFSvEKSiTTcuHR5GDf") {
    shortDescription
  }
  communityProjectsCollection(order: order_ASC) {
    items {
      name
      slug
    }
  }
  commisionCollection {
    items {
      slug
      name
      shortDescription
      description
    }
  }
}
    `;

/**
 * __useGetCollectionsListQuery__
 *
 * To run a query within a React component, call `useGetCollectionsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCollectionsListQuery(baseOptions?: Apollo.QueryHookOptions<GetCollectionsListQuery, GetCollectionsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionsListQuery, GetCollectionsListQueryVariables>(GetCollectionsListDocument, options);
      }
export function useGetCollectionsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionsListQuery, GetCollectionsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionsListQuery, GetCollectionsListQueryVariables>(GetCollectionsListDocument, options);
        }
export type GetCollectionsListQueryHookResult = ReturnType<typeof useGetCollectionsListQuery>;
export type GetCollectionsListLazyQueryHookResult = ReturnType<typeof useGetCollectionsListLazyQuery>;
export type GetCollectionsListQueryResult = Apollo.QueryResult<GetCollectionsListQuery, GetCollectionsListQueryVariables>;